<template>
	<div class="app-container">
		<el-card class="filter-card" shadow="hover">
			<el-form :inline="true" :model="filterForm" class="filter-form">
				<el-form-item>
					<el-button type="primary" @click="handleAddOpportunity">
						<el-icon>
							<Plus />
						</el-icon> 添加商机
					</el-button>
				</el-form-item>
				<el-form-item>
					<el-divider direction="vertical"></el-divider>
				</el-form-item>
				<el-form-item label="商机名称">
					<el-input v-model="filterForm.name" style="width: 180px" placeholder="请输入商机名称" clearable />
				</el-form-item>
				<el-form-item label="客户名称">
					<!-- <el-input v-model="filterForm.customerName" placeholder="请输入客户名称" clearable @keyup.enter="handleSearch" /> -->
					<el-select v-model="filterForm.customerId" placeholder="请选择客户" filterable remote
						:remote-method="handleCustomerSearch" :loading="customerSearchLoading" clearable>
						<el-option v-for="item in customerOptions" :key="item.id" :label="item.customerName"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="客户名称">
          <el-input v-model="filterForm.customerName" placeholder="请输入客户名称"></el-input>
        </el-form-item> -->
				<el-form-item label="商机状态">
					<el-select v-model="filterForm.stage" placeholder="商机状态" style="width: 130px;" clearable>
						<el-option label="初步接触" :value="0"></el-option>
						<el-option label="需求确认" :value="1"></el-option>
						<el-option label="方案报价" :value="2"></el-option>
						<el-option label="商务谈判" :value="3"></el-option>
						<el-option label="赢单" :value="4"></el-option>
						<el-option label="输单" :value="5"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="商机状态">
					<el-select v-model="filterForm.type" placeholder="请选择商机状态" style="width: 130px;">
						<el-option label="全部" value="all"></el-option>
						<el-option label="我的" value="my"></el-option>
						<el-option label="下属的" value="subordinate"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleSearch">查询</el-button>
					<el-button @click="resetForm">重置</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<el-card class="table-card" shadow="hover">
			<el-table :data="opportunityList" style="width: 100%" height="calc(100vh - 320px)" stripe
				v-loading="loading">
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="name" label="商机名称" min-width="200"></el-table-column>
				<el-table-column prop="customerName" label="客户名称" min-width="260"></el-table-column>
				<el-table-column prop="expectedAmount" label="预计金额" width="160">
					<template #default="scope">
						<text class="text-price">{{ formatAmount(scope.row.expectedAmount) }}</text>
					</template>
				</el-table-column>
				<el-table-column prop="stage" label="商机状态" width="160">
					<template #default="scope">
						<el-tag :type="getStatusType(scope.row.stage)">
							{{ getStatusText(scope.row.stage) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="expectedCloseDate" label="预计成交日期" width="160">
					<template #default="scope">
						{{ formatDate(scope.row.expectedCloseDate) }}
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="200">
					<template #default="scope">
						{{ formatDateTime(scope.row.createTime) }}
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="160">
					<template #default="scope">
						<el-button size="small" type="warning" @click="handleView(scope.row)">详情</el-button>
						<el-button size="small" type="primary"
							@click="handleEdit(scope.row)">编辑</el-button>
						<!-- <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination-container">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</el-card>

		<!-- 添加/编辑商机对话框 -->
		<el-dialog class="mydialog" :title="dialogTitle" v-model="dialogVisible" width="50vw"
			:close-on-click-modal="false" align-center>
			<el-card shadow="never">
				<el-form :model="opportunityForm" :rules="rules" ref="opportunityForm" label-width="auto">
					<el-form-item label="商机名称" prop="name">
						<el-col :span="14">
							<el-input v-model="opportunityForm.name" clearable />
						</el-col>
					</el-form-item>
					<el-form-item label="所属客户" prop="customerId">
						<el-col :span="18">
							<el-select v-model="opportunityForm.customerId" filterable placeholder="请选择客户">
								<el-option v-for="customer in customerList" :key="customer.id"
									:label="customer.customerName" :value="customer.id">
								</el-option>
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="预计金额" prop="expectedAmount">
						<el-input-number v-model="opportunityForm.expectedAmount" :min="0" :precision="2" :step="1000"
							style="width: 200px;" />
					</el-form-item>
					<el-form-item label="商机状态" prop="stage">
						<el-col :span="14">
							<el-select v-model="opportunityForm.stage" placeholder="请选择商机状态">
								<el-option label="初步接触" :value="0"></el-option>
								<el-option label="需求确认" :value="1"></el-option>
								<el-option label="方案报价" :value="2"></el-option>
								<el-option label="商务谈判" :value="3"></el-option>
								<el-option label="赢单" :value="4"></el-option>
								<el-option label="输单" :value="5"></el-option>
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="预计成交日期" prop="expectedCloseDate">
						<el-date-picker v-model="opportunityForm.expectedCloseDate" type="date" placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="商机描述" prop="description">
						<el-input type="textarea" v-model="opportunityForm.description" :rows="4" />
					</el-form-item>
				</el-form>
			</el-card>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitForm">确 定</el-button>
				</span>
			</template>

		</el-dialog>

		<!-- 查看商机详情对话框 -->
		<el-dialog class="mydialog" title="商机详情" v-model="viewDialogVisible" width="60vw" :close-on-click-modal="false"
			align-center>
			<el-tabs v-model="activeTab" type="border-card">
				<!-- 基本信息 -->
				<el-tab-pane label="基本信息" name="basic">
					<div class="followup-container">
						<div class="contacts-section height">
							<el-descriptions :column="2" border>
								<el-descriptions-item label="商机名称">{{ viewOpportunity.name }}</el-descriptions-item>
								<el-descriptions-item
									label="客户名称">{{ viewOpportunity.customerName }}</el-descriptions-item>
								<el-descriptions-item
									label="预计金额">¥{{ formatAmount(viewOpportunity.expectedAmount) }}</el-descriptions-item>
								<el-descriptions-item label="商机状态">
									<el-tag :type="getStatusType(viewOpportunity.stage)">
										{{ getStatusText(viewOpportunity.stage) }}
									</el-tag>
								</el-descriptions-item>
								<el-descriptions-item
									label="预计成交日期">{{ formatDate(viewOpportunity.expectedCloseDate) }}</el-descriptions-item>
								<el-descriptions-item
									label="创建时间">{{ formatDateTime(viewOpportunity.createTime) }}</el-descriptions-item>
								<el-descriptions-item label="商机描述" :span="2">
									<span style="white-space: pre-wrap">{{ viewOpportunity.description || '无' }}</span>
								</el-descriptions-item>
							</el-descriptions>
						</div>
					</div>
				</el-tab-pane>

				<!-- 跟进记录 -->
				<el-tab-pane label="跟进记录" name="followup">
					<bus-activities :records="followupRecords0" @add-followup="handleAddFollowup" />
					<!-- <div class="followup-header">
							<el-button type="primary" size="small" @click="handleAddFollowup">
								<i class="el-icon-plus"></i> 添加跟进记录
							</el-button>
						</div>
						<div class="contacts-section height">
						<el-timeline>
							<el-timeline-item v-for="(record, index) in followupRecords0" :key="index"
								:timestamp="formatDateTime(record.createTime)" :type="getFollowupType(record.type)"
								:hollow="record.type === 'other'" :color="getFollowupColor(record.type)">
								<el-card class="followup-card">
									<template #header>
										<div class="followup-header">
											<span class="followup-title">{{ record.subject }}</span>
											<el-tag size="small"
												:type="getFollowupType(record.type)">{{ getFollowupTypeText(record.type) }}</el-tag>
										</div>
									</template>
									<div class="followup-content">
										<div class="followup-info">
											<p><i class="el-icon-time"></i> 时间：{{ formatDateTime(record.startTime) }} -
												{{ formatDateTime(record.endTime) }}
											</p>
											<p><i class="el-icon-location"></i> 地点：{{ record.location || '未设置' }}</p>
											<p v-if="record.lng && record.lat">
												<i class="el-icon-map-location"></i> 坐标：{{ record.lng }},
												{{ record.lat }}
											</p>
											<p><i class="el-icon-user"></i> 跟进人：{{ record.username }}</p>
										</div>
										<div class="followup-notes">
											<h4>跟进内容：</h4>
											<p>{{ record.notes }}</p>
										</div>
										<div v-if="record.photos && record.photos.length > 0" class="followup-photos">
											<h4>相关图片：</h4>
											<el-image v-for="(photo, photoIndex) in record.photos" :key="photoIndex"
												:src="photo" :preview-src-list="record.photos" fit="cover"
												class="followup-photo">
											</el-image>
										</div>
									</div>
								</el-card>
							</el-timeline-item>
						</el-timeline>
						</div> -->
				</el-tab-pane>

				<!-- 报价明细 -->
				<el-tab-pane label="报价明细" name="quotations">
					<!-- <bus-offer :records="quotationList" @add-followup="handleAddQuotation" /> -->
					<div class="followup-container">
						<div class="followup-header">
							<el-col :span="18">
							</el-col>
							<el-col :span="6">
								<el-button type="primary" @click="handleAddQuotation">
									<el-icon>
										<Plus />
									</el-icon> 新建报价
								</el-button>
							</el-col>
						</div>
						<div class="contacts-section height">
							<el-table :data="quotationList" border style="width: 100%">
								<el-table-column type="index" label="序号" width="60" />
								<el-table-column prop="name" label="报价编号" min-width="150"></el-table-column>
								<el-table-column prop="customerName" label="客户名称" min-width="240"></el-table-column>
								<el-table-column prop="offerPrice" label="报价金额" min-width="100">
									<template #default="{ row }">
										{{ formatAmount(row.offerPrice) }}
									</template>
								</el-table-column>
								<el-table-column prop="offerTime" label="报价时间" width="120">
									<template #default="{ row }">
										{{ formatDate(row.offerTime) }}
									</template>
								</el-table-column>
								<el-table-column prop="status" label="报价状态" width="120">
									<template #default="{ row }">
										<el-tag :type="getStatusTypeOffer(row.status)">
											{{ getStatusTextOffer(row.status) }}
										</el-tag>
									</template>
								</el-table-column>
								<el-table-column prop="createTime" label="创建时间" width="180">
									<template #default="{ row }">
										{{ formatDateTime(row.createTime) }}
									</template>
								</el-table-column>
								<el-table-column label="操作" width="280" fixed="right">
									<template #default="{ row }">
										<el-button size="small" type="warning"
											@click="handleViewQuotation(row)">查看</el-button>
										<el-button size="small" type="success"
											@click="handleExportQuotation(row)">导出</el-button>
										<el-button v-if="row.status === 9 || row.status === 4" size="small"
											type="primary" @click="handleEditQuotation(row)">编辑</el-button>
										<el-button v-if="row.status === 9 || row.status === 4" size="small"
											type="success" @click="handleSubmitQuotation(row)">审批</el-button>
										<el-button v-if="row.status === 0" size="small" type="danger"
											@click="handleSubmitQuotation(row)">撤回</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</el-tab-pane>

				<!-- 合同明细 -->
				<el-tab-pane label="合同明细" name="contracts">
					<div class="followup-container">
						<div class="followup-header">
							<el-col :span="18">
							</el-col>
							<el-col :span="6">
								<el-button type="primary" @click="handleAddContract">
									<el-icon>
										<Plus />
									</el-icon> 新建合同
								</el-button>
							</el-col>
						</div>
						<div class="contacts-section height">
							<el-table :data="contractList" border style="width: 100%">
								<el-table-column type="index" label="序号" width="60" />
								<el-table-column prop="contractNumber" label="合同编号">
									<template #default="{ row }">
										<el-link type="primary"
											@click="handleViewContract(row)">{{ row.contractNumber }}</el-link>
									</template>
								</el-table-column>
								<el-table-column prop="contractName" label="合同名称" />
								<el-table-column prop="totalAmount" label="合同金额">
									<template #default="{ row }">
										¥{{ formatAmount(row.totalAmount) }}
									</template>
								</el-table-column>
								<el-table-column prop="signedDate" label="签订日期">
									<template #default="{ row }">
										{{ formatDate(row.signedDate) }}
									</template>
								</el-table-column>
								<!-- <el-table-column prop="status" label="状态">
                  <template #default="{ row }">
                    <el-tag :type="getContractStatusType(row.status)">
                      {{ getContractStatusText(row.status) }}
                    </el-tag>
                  </template>
                </el-table-column> -->
								<el-table-column label="操作" width="200" fixed="right">
									<template #default="{ row }">
										<el-button size="small" type="warning"
											@click="handleViewContract(row)">查看</el-button>
										<el-button size="small" type="primary"
											@click="handleEditContract(row)">编辑</el-button>
										<el-button size="small" type="danger"
											@click="handleDeleteContract(row)">删除</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</el-tab-pane>

				<!-- 回款明细 -->
				<el-tab-pane label="回款明细" name="payments">
					<div class="followup-container">
						<div class="followup-header">
							<el-col :span="18">
							</el-col>
							<el-col :span="6">
								<el-button type="primary" @click="handleAddPayment">
									<el-icon>
										<Plus />
									</el-icon> 新建回款
								</el-button>
							</el-col>
						</div>
						<div class="contacts-section height">
							<el-table :data="paymentList" border style="width: 100%">
								<el-table-column type="index" label="序号" width="60" />
								<el-table-column prop="number" label="回款编号">
									<template #default="{ row }">
										<el-link type="primary"
											@click="handleViewPayment(row)">{{ row.number }}</el-link>
									</template>
								</el-table-column>
								<el-table-column prop="money" label="回款金额">
									<template #default="{ row }">
										¥{{ formatAmount(row.money) }}
									</template>
								</el-table-column>
								<el-table-column prop="returnTime" label="回款时间">
									<template #default="{ row }">
										{{ formatDateTime(row.returnTime) }}
									</template>
								</el-table-column>
								<el-table-column prop="returnType" label="回款方式" />
								<!-- <el-table-column prop="status" label="状态">
                  <template #default="{ row }">
                    <el-tag :type="getPaymentStatusType(row.checkStatus)">
                      {{ getPaymentStatusText(row.checkStatus) }}
                    </el-tag>
                  </template>
                </el-table-column> -->
								<el-table-column label="操作" width="200" fixed="right">
									<template #default="{ row }">
										<el-button size="small" type="warning"
											@click="handleViewPayment(row)">查看</el-button>
										<el-button size="small" type="primary"
											@click="handleEditPayment(row)">编辑</el-button>
										<el-button size="small" type="danger"
											@click="handleDeletePayment(row)">删除</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</el-tab-pane>

				<!-- 团队明细 -->
				<el-tab-pane label="团队明细" name="team">
					<div class="followup-container">
						<div class="followup-header">
							<el-col :span="18">
							</el-col>
							<el-col :span="6">
								<el-button type="primary" @click="handleAddTeamMember">
									<el-icon>
										<Plus />
									</el-icon> 添加成员
								</el-button>
							</el-col>
						</div>
						<div class="contacts-section height">
							<el-table :data="teamList" border style="width: 100%">
								<el-table-column type="index" label="序号" width="60" />
								<el-table-column prop="username" label="成员姓名" />
								<el-table-column prop="power" label="角色">
									<template #default="{ row }">
										<el-tag :type="getTeamRoleType(row.power)">
											{{ getTeamRoleText(row.power) }}
										</el-tag>
									</template>
								</el-table-column>
								<el-table-column prop="createTime" label="加入时间" width="180">
									<template #default="{ row }">
										{{ formatDateTime(row.createTime) }}
									</template>
								</el-table-column>
								<el-table-column label="操作" width="100">
									<template #default="{ row }">
										<el-button v-if="row.userId !== viewOpportunity.ownerId" type="danger"
											size="small" @click="handleRemoveTeamMember(row)">
											移除
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>

		<!-- 审批详情对话框 -->
		<el-dialog class="mydialog" title="审批详情" v-model="viewApprovalDialogVisible" width="800px"
			:close-on-click-modal="false">
			<el-tabs v-model="activeApprovalTab">
				<el-tab-pane label="基本信息" name="basic">
					<el-descriptions :column="2" border>
						<el-descriptions-item label="审批类型">{{ getTypeText(viewApproval.oaType) }}</el-descriptions-item>
						<el-descriptions-item label="审批标题">{{ viewApproval.examineName }}</el-descriptions-item>
						<el-descriptions-item label="申请人">{{ viewApproval.username }}</el-descriptions-item>
						<el-descriptions-item
							label="申请时间">{{ formatDateTime(viewApproval.createTime) }}</el-descriptions-item>
						<el-descriptions-item label="审批状态">
							<el-tag :type="getApprovalStatusType1(viewApproval.status)">
								{{ getApprovalStatusText1(viewApproval.status) }}
							</el-tag>
						</el-descriptions-item>
						<el-descriptions-item label="当前审批人">{{ viewApproval.currentApprover }}</el-descriptions-item>
					</el-descriptions>
				</el-tab-pane>

				<el-tab-pane label="审批流程" name="process">
					<el-timeline>
						<el-timeline-item v-for="(activity, index) in viewApproval.process" :key="index"
							:type="getTimelineItemType(activity.status)" :timestamp="formatDateTime(activity.time)">
							<div class="timeline-item-content">
								<h4>第{{ index + 1 }}步</h4>
								<p><strong>审批人：</strong>{{ activity.username }}</p>
								<p><strong>审批状态：</strong>
									<el-tag :type="getApprovalStatusType(activity.status)" size="small">
										{{ getApprovalStatusText(activity.status) }}
									</el-tag>
								</p>
								<p v-if="activity.examineOpinion"><strong>审批意见：</strong>{{ activity.examineOpinion }}
								</p>
								<p><strong>审批时间：</strong>{{ formatDateTime(activity.updateTime) }}</p>
							</div>
						</el-timeline-item>
					</el-timeline>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>

		<!-- 添加跟进记录对话框 -->
		<el-dialog :title="followupFormTitle" v-model="followupDialogVisible" width="40vw" :close-on-click-modal="false"
			align-center>
			<!-- <img src="@/assets/crm.png" style="width: 100%; height: 100%;" /> -->
			<el-form :model="followupForm" :rules="followupRules" ref="followupForm" label-width="auto">
				<el-form-item label="关联商机" prop="businessId">
					<text>{{ followupForm.businessName }}</text>
				</el-form-item>
				<el-form-item label="关联客户" prop="customerId">
					<text>{{ followupForm.customerName }}</text>
				</el-form-item>
				<el-form-item label="关联回款" prop="receivablesId" v-if="followupForm.receivablesId">
					<text>{{ followupForm.receivablesName }}</text>
				</el-form-item>
				<el-form-item label="跟进主题" prop="subject">
					<el-col :span="20">
						<el-input v-model="followupForm.subject" placeholder="请输入跟进主题"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="跟进方式" prop="type">
					<el-col :span="14">
						<el-select v-model="followupForm.type" placeholder="请选择跟进方式">
							<el-option label="电话沟通" value="电话沟通"></el-option>
							<el-option label="邮件往来" value="邮件往来"></el-option>
							<el-option label="实地拜访" value="实地拜访"></el-option>
							<el-option label="其他" value="其他"></el-option>
						</el-select>
					</el-col>
				</el-form-item>

				<!-- <el-form-item label="跟进类型" prop="classify">
              <el-select v-model="followupForm.classify" placeholder="请选择跟进类型">
                <el-option label="商机跟进" :value="0"></el-option>
                <el-option label="跟进跟进" :value="1"></el-option>
              </el-select>
            </el-form-item> -->
				<el-form-item label="跟进时间" prop="startTime">
					<!-- <el-date-picker v-model="followupForm.startTime" type="datetime" placeholder="选择开始时间"
						format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm:ss">
					</el-date-picker> -->
					<el-col :span="20">
						<el-date-picker v-model="startendTime" type="datetimerange" range-separator="至"
							start-placeholder="开始时间" end-placeholder="结束时间">
						</el-date-picker>
					</el-col>
				</el-form-item>
				<!-- <el-form-item label="结束时间" prop="endTime">
					<el-date-picker v-model="followupForm.endTime" type="datetime" placeholder="选择结束时间"
						format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm:ss">
					</el-date-picker>
				</el-form-item> -->
				<el-form-item label="地点" prop="location">
					<el-input v-model="followupForm.location" placeholder="请输入地点"></el-input>
				</el-form-item>
				<el-form-item label="经纬度" prop="lng">
					<el-row :gutter="10">
						<el-col :span="12">
							<!-- <el-form-item prop="lng" :rules="{ required: true, message: '请输入经度', trigger: 'blur' }"> -->
							<el-form-item>
								<el-input v-model="followupForm.lng" placeholder="经度"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<!-- <el-form-item prop="lat" :rules="{ required: true, message: '请输入纬度', trigger: 'blur' }"> -->
							<el-form-item>
								<el-input v-model="followupForm.lat" placeholder="纬度"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form-item>
				<!-- <el-form-item label="照片" prop="pic" :rules="[{ required: true, message: '请上传照片', trigger: 'change' }]"> -->
				<el-form-item label="照片">
					<el-upload action="/api/move/uploadPic" list-type="picture-card"
						:on-preview="handlePictureCardPreview" :on-remove="handleRemove"
						:on-success="handleUploadSuccess" :on-error="handleUploadError" :before-upload="beforeUpload"
						:headers="uploadHeaders" :limit="1" :on-exceed="handleExceed" :file-list="fileList"
						:show-file-list="true">
						<div class="upload-trigger">
							<el-icon>
								<Plus />
							</el-icon>
							<!-- <img v-else :src="fileList[0].url" class="uploaded-image" /> -->
						</div>
					</el-upload>
					<el-dialog v-model="previewVisible">
						<img w-full :src="previewUrl" alt="Preview Image" />
					</el-dialog>
				</el-form-item>
				<el-form-item label="跟进内容" prop="notes">
					<el-input type="textarea" v-model="followupForm.notes" :rows="4" placeholder="请输入跟进内容"></el-input>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="followupDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitFollowup">确 定</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 报价表单对话框 -->
		<el-dialog class="mydialog" :title="quotationFormTitle" v-model="quotationFormVisible" width="60vw"
			:close-on-click-modal="false" align-center>
			<el-form :model="quotationForm" :rules="quotationRules" ref="quotationForm" label-width="auto">
				<el-row>
					<el-col :span="20">
						<el-form-item label="报价名称" prop="name">
							<el-input v-model="quotationForm.name" placeholder="请输入报价名"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="客户" prop="customerId">
							<el-input v-model="quotationForm.customerName" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="所属商机" prop="businessId">
							<el-input v-model="quotationForm.businessName" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="20">
						<el-form-item label="报价到期时间" prop="offerTime">
							<el-date-picker v-model="quotationForm.offerTime" type="date" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="报价" prop="offerPrice">
							<el-input-number v-model="quotationForm.offerPrice" :min="0"
								:precision="2"></el-input-number>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="8">
						<el-form-item label="成本" prop="cost">
							<el-input-number v-model="quotationForm.cost" :min="0" :precision="2"></el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="利润" prop="profit">
							<el-input-number v-model="quotationForm.profit" :min="0" :precision="2"></el-input-number>
						</el-form-item>
					</el-col> -->
					<el-col :span="20">
						<el-form-item label="备注说明" prop="remark">
							<el-input type="textarea" v-model="quotationForm.remark" :rows="3"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<div class="contacts-section border ">
					<div class="contacts-header">
						<el-col :span="16">
							<h3>报价明细</h3>
						</el-col>
						<el-col :span="4">
							<el-button type="primary" size="small" @click="showProductSelector">
								<i class="el-icon-plus"></i> 选择产品
							</el-button>
						</el-col>
						<el-col :span="4">
							<el-button type="primary" size="small" @click="importQuotation">
								<i class="el-icon-plus"></i> 导入报价
							</el-button>
						</el-col>
					</div>
					<el-table :data="quotationForm.products" border stripe height="calc(100% - 75px)"
						style="width: 100%">
						<el-table-column type="index" label="序号" width="60" />
						<el-table-column prop="name" label="产品名称" min-width="200"></el-table-column>
						<el-table-column prop="specification" label="规格型号" width="120"></el-table-column>
						<el-table-column label="数量" width="180">
							<template #default="scope">
								<el-input-number v-model="scope.row.quantity" :min="1"
									@change="calculateItemAmount(scope.$index)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="unit" label="单位" width="70"></el-table-column>
						<el-table-column label="单价" width="200">
							<template #default="scope">
								<el-input-number v-model="scope.row.unitPrice" :min="0" :precision="2"
									@change="calculateItemAmount(scope.$index)"></el-input-number>
							</template>
						</el-table-column>
						<!-- <el-table-column label="成本价" width="180">
							<template #default="scope">
								<el-input-number v-model="scope.row.costPrice" :min="0" :precision="2"
									@change="calculateItemAmount(scope.$index)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="amount" label="金额" width="180">
							<template #default="scope">
								{{ formatAmount(scope.row.amount) }}
							</template>
						</el-table-column> -->
						<el-table-column label="操作" width="80" fixed="right">
							<template #default="scope">
								<el-button type="danger" size="small" @click="removeQuotationItem(scope.$index)">
									<el-icon>
										<Delete />
									</el-icon>
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="quotationFormVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitQuotationForm">确 定</el-button>
				</span>
			</template>
		</el-dialog>
        <!-- 报价表单对话框 -->
        <el-dialog :title="quotationFormTitle" v-model="quotationFormVisible" width="1380px" :close-on-click-modal="false">
          <el-form :model="quotationForm" :rules="quotationRules" ref="quotationForm" label-width="100px">
            <el-form-item label="报价编号" prop="name">
              <el-input v-model="quotationForm.name" placeholder="请输入报价编号"></el-input>
            </el-form-item>
            <el-form-item label="客户名称" prop="customerId">
              <el-input v-model="quotationForm.customerName" disabled></el-input>
            </el-form-item>
            <el-form-item label="所属商机" prop="businessId">
              <el-input v-model="quotationForm.businessName" disabled></el-input>
            </el-form-item>
            <el-form-item label="报价到期时间" prop="offerTime">
                    <el-date-picker v-model="quotationForm.offerTime" type="date" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            <el-form-item label="报价" prop="offerPrice">
              <el-input-number v-model="quotationForm.offerPrice" :min="0" :precision="2" :disabled="true"></el-input-number>
            </el-form-item>
            <!-- <el-form-item label="成本" prop="cost">
              <el-input-number v-model="quotationForm.cost" :min="0" :precision="2"></el-input-number>
            </el-form-item>
            <el-form-item label="利润" prop="profit">
              <el-input-number v-model="quotationForm.profit" :min="0" :precision="2"></el-input-number>
            </el-form-item> -->
            <div class="quotation-items">
              <div class="items-header">
                <h3>报价明细</h3>
                <el-button type="primary" size="small" @click="showProductSelector">
                  <i class="el-icon-plus"></i> 添加产品
                </el-button>
                <el-button type="primary" size="small" @click="importQuotation">
                  <i class="el-icon-plus"></i> 导入报价
                </el-button>
              </div>
              <el-table :data="quotationForm.products" border style="width: 100%">
                        <el-table-column type="index" label="序号" width="60" />
                        <el-table-column prop="name" label="产品名称" width="200"></el-table-column>
                        <el-table-column prop="specification" label="规格型号" width="120"></el-table-column>
                        <el-table-column label="数量" width="180">
                            <template #default="scope">
                                <el-input-number v-model="scope.row.quantity" :min="1"
                                    @change="calculateItemAmount(scope.$index)"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column prop="unit" label="单位" width="120"></el-table-column>
                        <el-table-column label="单价" width="180">
                            <template #default="scope">
                                <el-input-number v-model="scope.row.unitPrice" :min="0" :precision="2"
                                    @change="calculateItemAmount(scope.$index)"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="成本价" width="180" v-show="false">
                            <template #default="scope">
                                <el-input-number v-model="scope.row.costPrice" :min="0" :precision="2"
                                    @change="calculateItemAmount(scope.$index)"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column prop="amount" label="金额" width="180">
                            <template #default="scope">
                                {{ formatAmount(scope.row.amount) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="120">
                            <template #default="scope">
                                <el-button type="danger" size="mini" icon="el-icon-delete"
                                    @click="removeQuotationItem(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
            </div>
            <el-form-item label="备注说明" prop="remark">
              <el-input type="textarea" v-model="quotationForm.remark" :rows="3"></el-input>
            </el-form-item>
          </el-form>
          <template #footer>
            <span class="dialog-footer">
              <el-button @click="quotationFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="submitQuotationForm">确 定</el-button>
            </span>
          </template>
        </el-dialog>

		<!-- 产品选择器对话框 -->
		<el-dialog class="mydialog" title="选择产品" v-model="productSelectorVisible" width="50vw"
			:close-on-click-modal="false" align-center>
			<div class="contacts-section">
				<div class="contacts-header">
					<el-input v-model="productSearchKeyword" placeholder="请输入产品名称或型号" style="width: 300px"
						@input="handleProductSearch">
						<template #prefix>
							<el-icon>
								<Search />
							</el-icon>
						</template>
					</el-input>
					<el-button type="primary" size="small" @click="showAddProduct">
						<el-icon>
							<Plus />
						</el-icon> 新增产品
					</el-button>
				</div>
				<el-table :data="filteredProducts" border stripe style="width: 100%"
					@selection-change="handleProductSelectionChange">
					<el-table-column type="selection" width="55" />
					<el-table-column prop="name" label="产品名称" />
					<el-table-column prop="specification" label="规格型号" />
					<el-table-column prop="unit" label="单位" width="100" />
					<el-table-column prop="unitPrice" label="单价" width="120">
						<template #default="scope">
							{{ formatAmount(scope.row.unitPrice) }}
						</template>
					</el-table-column>
					<el-table-column prop="costPrice" label="成本价" width="120">
						<template #default="scope">
							{{ formatAmount(scope.row.costPrice) }}
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination-container">
					<el-pagination @size-change="handleProductSizeChange" @current-change="handleProductCurrentChange"
						:current-page="productCurrentPage" :page-sizes="[10, 20, 50, 100]" :page-size="productPageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="productTotal">
					</el-pagination>
				</div>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="productSelectorVisible = false">取 消</el-button>
					<el-button type="primary" @click="confirmProductSelection">确 定</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 新增产品对话框 -->
		<el-dialog title="新增产品" v-model="addProductVisible" width="40vw" :close-on-click-modal="false" align-center>
			<el-form :model="productForm" :rules="productRules" ref="productForm" label-width="100px">
				<el-form-item label="产品名称" prop="name">
					<el-input v-model="productForm.name" placeholder="请输入产品名称"></el-input>
				</el-form-item>
				<el-form-item label="规格型号" prop="specification">
					<el-input v-model="productForm.specification" placeholder="请输入规格型号"></el-input>
				</el-form-item>
				<el-form-item label="单位" prop="unit">
					<el-input v-model="productForm.unit" placeholder="请输入单位"></el-input>
				</el-form-item>
				<el-form-item label="单价" prop="unitPrice">
					<el-input-number v-model="productForm.unitPrice" :min="0" :precision="2"></el-input-number>
				</el-form-item>
				<el-form-item label="成本价" prop="costPrice">
					<el-input-number v-model="productForm.costPrice" :min="0" :precision="2"></el-input-number>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input type="textarea" v-model="productForm.remark" :rows="3" placeholder="请输入备注"></el-input>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="addProductVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitProductForm">确 定</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 报价详情对话框 -->
		<el-dialog title="报价详情" v-model="quotationDialogVisible" width="60vw" :close-on-click-modal="false"
			align-center>
			<el-tabs v-model="quotationActiveTab">
				<!-- 基本信息 -->
				<el-tab-pane label="基本信息" name="basic">
					<el-descriptions :column="2" border>
						<el-descriptions-item label="报价编号">{{ currentQuotation.name }}</el-descriptions-item>
						<el-descriptions-item label="客户名称">{{ currentQuotation.customerName }}</el-descriptions-item>
						<el-descriptions-item
							label="报价金额">{{ formatAmount(currentQuotation.offerPrice) }}</el-descriptions-item>
						<el-descriptions-item label="报价状态">
							<el-tag :type="getStatusTypeOffer(currentQuotation.status)">
								{{ getStatusTextOffer(currentQuotation.status) }}
							</el-tag>
						</el-descriptions-item>
						<el-descriptions-item
							label="报价时间">{{ formatDateTime(currentQuotation.offerTime) }}</el-descriptions-item>
						<el-descriptions-item
							label="创建时间">{{ formatDateTime(currentQuotation.createTime) }}</el-descriptions-item>
						<el-descriptions-item label="备注" :span="2">
							<span style="white-space: pre-wrap">{{ currentQuotation.remark || '无' }}</span>
						</el-descriptions-item>
					</el-descriptions>
				</el-tab-pane>

				<el-tab-pane label="报价明细" name="details">
					<el-table :data="currentQuotation.businessProducts" border style="width: 100%">
						<el-table-column type="index" label="序号" width="60" />
						<el-table-column prop="productName" label="产品名称"></el-table-column>
						<el-table-column prop="productNum" label="数量" width="100"></el-table-column>
						<el-table-column prop="unit" label="单位" width="80"></el-table-column>
						<el-table-column prop="productPrice" label="单价" width="120">
							<template #default="scope">
								{{ formatAmount(scope.row.productPrice) }}
							</template>
						</el-table-column>
						<el-table-column prop="amount" label="金额" width="120">
							<template #default="scope">
								{{ formatAmount(scope.row.amount) }}
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>

				<!-- 审批列表 -->
				<el-tab-pane label="审批列表" name="approval">
					<div class="approval-process" v-if="approvalList.length > 0">
						<el-table :data="approvalList" border style="width: 100%">
							<el-table-column type="index" label="序号" width="60" />
							<el-table-column prop="examineName" label="审批标题" min-width="200" />
							<el-table-column prop="username" label="申请人" width="120" />
							<el-table-column prop="createTime" label="申请时间" width="180">
								<template #default="scope">
									{{ formatDateTime(scope.row.createTime) }}
								</template>
							</el-table-column>
							<el-table-column prop="status" label="审批状态" width="100">
								<template #default="scope">
									<el-tag :type="getApprovalStatusType1(scope.row.status)" size="small">
										{{ getApprovalStatusText1(scope.row.status) }}
									</el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="currentApprover" label="当前审批人" width="120" />
							<el-table-column label="操作" width="120">
								<template #default="scope">
									<el-button size="mini" type="info"
										@click="handleViewApproval(scope.row)">查看</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-empty v-else description="暂无审批信息"></el-empty>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>

		<!-- 审批表单对话框 -->
		<el-dialog :title="approvalFormTitle" v-model="approvalFormVisible" width="600px">
			<el-form :model="approvalForm" :rules="approvalRules" ref="approvalForm" label-width="100px">
				<el-form-item label="审批名称" prop="examineName">
					<el-input v-model="approvalForm.examineName" placeholder="请输入审批名称"></el-input>
				</el-form-item>
				<el-form-item label="审批模板" prop="examineTemId">
					<el-select v-model="approvalForm.examineTemId" placeholder="请选择审批模板" @change="handleTemplateChange">
						<el-option v-for="item in templateList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="审批类型" prop="oaType">
					<el-select v-model="approvalForm.oaType" placeholder="请选择审批类型">
						<el-option label="报价审批" value="quotation"></el-option>
						<el-option label="合同审批" value="contract"></el-option>
						<el-option label="其他审批" value="other"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="关联商机" prop="businessId">
					<el-input v-model="approvalForm.businessName" disabled></el-input>
				</el-form-item>
				<el-form-item label="关联客户" prop="customerId">
					<el-input v-model="approvalForm.customerName" disabled></el-input>
				</el-form-item>
				<el-form-item label="审批说明" prop="description">
					<el-input type="textarea" v-model="approvalForm.description" :rows="4"
						placeholder="请输入审批说明"></el-input>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="approvalFormVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitApprovalForm">确 定</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 提交审核对话框 -->
		<el-dialog title="提交审核" v-model="submitDialogVisible" width="500px" :close-on-click-modal="false">
			<el-form :model="submitForm1" :rules="submitRules" ref="submitFormRef" label-width="100px">
				<el-form-item label="审批名称" prop="examineName">
					<el-input v-model="submitForm1.examineName" placeholder="请输入审批名称"></el-input>
				</el-form-item>
				<el-form-item label="审批模板" prop="temId">
					<el-select v-model="submitForm1.temId" placeholder="请选择审批模板" filterable style="width: 100%">
						<el-option v-for="template in approvalTemplateList" :key="template.id" :label="template.name"
							:value="template.id">
							<div>
								<div>{{ template.name }}</div>
								<div style="font-size: 12px; color: #999;">
									{{ template.description }}
								</div>
							</div>
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="submitDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="confirmSubmit">确 定</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 合同表单对话框 -->
		<el-dialog :title="contractFormTitle" v-model="contractFormVisible" width="1380px"
			:close-on-click-modal="false">
			<el-form :model="contractForm" :rules="contractRules" ref="contractForm" label-width="100px">
				<el-form-item label="合同编号" prop="contractNumber">
					<el-input v-model="contractForm.contractNumber" placeholder="请输入合同编号"></el-input>
				</el-form-item>
				<el-form-item label="合同名称" prop="contractName">
					<el-input v-model="contractForm.contractName" placeholder="请输入合同名称"></el-input>
				</el-form-item>
				<el-form-item label="客户名称" prop="customerId">
					<el-input v-model="contractForm.customerName" disabled></el-input>
				</el-form-item>
				<el-form-item label="所属商机" prop="businessId">
					<el-input v-model="contractForm.businessName" disabled></el-input>
				</el-form-item>
				<el-form-item label="合同金额" prop="totalAmount">
					<el-input-number v-model="contractForm.totalAmount" :precision="2" :step="1000" :min="0"
						style="width: 200px" />
				</el-form-item>
				<el-form-item label="签订日期" prop="signedDate">
					<el-date-picker v-model="contractForm.signedDate" type="date" placeholder="选择日期"
						value-format="YYYY-MM-DD">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="生效日期" prop="startDate">
					<el-date-picker v-model="contractForm.startDate" type="date" placeholder="选择日期"
						value-format="YYYY-MM-DD">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="到期日期" prop="endDate">
					<el-date-picker v-model="contractForm.endDate" type="date" placeholder="选择日期"
						value-format="YYYY-MM-DD">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="合同内容" prop="paymentTerms">
					<el-input v-model="contractForm.paymentTerms" type="textarea" :rows="4" placeholder="请输入付款条款" />
				</el-form-item>
				<el-form-item label="备注说明" prop="notes">
					<el-input v-model="contractForm.notes" type="textarea" :rows="2" placeholder="请输入备注说明" />
				</el-form-item>
				<el-form-item label="合同文件" prop="contractFile"
					:rules="[{ required: true, message: '请上传合同文件', trigger: 'change' }]">
					<el-upload action="/api/move/uploadFile" :on-preview="handleContractFilePreview"
						:on-remove="handleContractFileRemove" :on-success="handleContractFileSuccess"
						:before-upload="beforeContractFileUpload" :headers="uploadHeaders" :limit="1"
						:on-exceed="handleContractFileExceed" :file-list="contractFileList" accept=".pdf"
						class="contract-upload">
						<el-button type="primary">选择文件</el-button>
						<template #tip>
							<div class="el-upload__tip">只能上传PDF文件</div>
						</template>
					</el-upload>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="contractFormVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitContractForm">确 定</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 合同详情对话框 -->
		<el-dialog title="合同详情" v-model="contractDialogVisible" width="1000px" :close-on-click-modal="false">
			<el-tabs v-model="contractActiveTab">
				<!-- 基本信息 -->
				<el-tab-pane label="基本信息" name="basic">
					<el-descriptions :column="2" border>
						<el-descriptions-item label="合同编号">{{ currentContract.contractNumber }}</el-descriptions-item>
						<el-descriptions-item label="合同名称">{{ currentContract.contractName }}</el-descriptions-item>
						<el-descriptions-item label="客户名称">{{ viewOpportunity.customerName }}</el-descriptions-item>
						<el-descriptions-item label="所属商机">{{ viewOpportunity.name }}</el-descriptions-item>
						<el-descriptions-item
							label="合同金额">{{ formatAmount(currentContract.totalAmount) }}</el-descriptions-item>
						<el-descriptions-item
							label="签订日期">{{ formatDate(currentContract.signedDate) }}</el-descriptions-item>
						<el-descriptions-item
							label="生效日期">{{ formatDate(currentContract.startDate) }}</el-descriptions-item>
						<el-descriptions-item
							label="到期日期">{{ formatDate(currentContract.endDate) }}</el-descriptions-item>
						<el-descriptions-item label="合同内容" :span="2">
							<span style="white-space: pre-wrap">{{ currentContract.paymentTerms || '无' }}</span>
						</el-descriptions-item>
						<el-descriptions-item label="备注说明" :span="2">
							<span style="white-space: pre-wrap">{{ currentContract.notes || '无' }}</span>
						</el-descriptions-item>
						<el-descriptions-item label="合同文件" :span="2">
							<el-link v-if="currentContract.contractFile" type="primary"
								@click="handleContractFilePreview({url:'/api/move/getOssFile?name='+ currentContract.contractFile})">
								查看合同文件
							</el-link>
							<span v-else>无</span>
						</el-descriptions-item>
						<el-descriptions-item
							label="创建时间">{{ formatDateTime(currentContract.createTime) }}</el-descriptions-item>
						<!-- <el-descriptions-item label="状态">
                  <el-tag :type="getContractStatusType(currentContract.status)">
                    {{ getContractStatusText(currentContract.status) }}
                  </el-tag>
                </el-descriptions-item> -->
					</el-descriptions>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>

		<!-- 回款表单对话框 -->
		<el-dialog :title="paymentFormTitle" v-model="paymentFormVisible" width="600px" :close-on-click-modal="false">
			<el-form :model="paymentForm" :rules="paymentRules" ref="paymentForm" label-width="100px">
				<el-form-item label="回款编号" prop="number">
					<el-input v-model="paymentForm.number" placeholder="请输入回款编号"></el-input>
				</el-form-item>
				<el-form-item label="客户名称" prop="customerId">
					<el-input v-model="paymentForm.customerName" disabled></el-input>
				</el-form-item>
				<el-form-item label="所属商机" prop="businessId">
					<el-input v-model="paymentForm.businessName" disabled></el-input>
				</el-form-item>
				<el-form-item label="所属合同" prop="contractId">
					<el-select v-model="paymentForm.contractId" placeholder="请选择合同" filterable
						:loading="contractLoading">
						<el-option v-for="item in contractList" :key="item.id" :label="item.contractNumber"
							:value="item.id">
							<span>{{ item.contractNumber }}</span>
							<span style="float: right; color: #8492a6; font-size: 13px">
								金额: {{ formatAmount(item.totalAmount) }}
							</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="回款金额" prop="money">
					<el-input-number v-model="paymentForm.money" :min="0" :precision="2"></el-input-number>
				</el-form-item>
				<el-form-item label="回款时间" prop="returnTime">
					<el-date-picker v-model="paymentForm.returnTime" type="datetime" placeholder="选择日期时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="回款方式" prop="returnType">
					<el-select v-model="paymentForm.returnType" placeholder="请选择回款方式">
						<el-option label="现金" value="现金"></el-option>
						<el-option label="银行转账" value="银行转账"></el-option>
						<el-option label="支票" value="支票"></el-option>
						<el-option label="其他" value="其他"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="回款单" prop="receiptFile"
					:rules="[{ required: true, message: '请上传回款单', trigger: 'change' }]">
					<el-upload action="/api/move/uploadFile" :on-preview="handleReceiptFilePreview"
						:on-remove="handleReceiptFileRemove" :on-success="handleReceiptFileSuccess"
						:before-upload="beforeReceiptFileUpload" :headers="uploadHeaders" :limit="1"
						:on-exceed="handleReceiptFileExceed" :file-list="receiptFileList" accept=".pdf,.jpg,.jpeg,.png"
						class="receipt-upload">
						<el-button type="primary">选择文件</el-button>
						<template #tip>
							<div class="el-upload__tip">支持PDF、JPG、PNG格式</div>
						</template>
					</el-upload>
				</el-form-item>
				<el-form-item label="备注说明" prop="remark">
					<el-input type="textarea" v-model="paymentForm.remark" :rows="3" placeholder="请输入备注说明"></el-input>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="paymentFormVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitPaymentForm">确 定</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 回款详情对话框 -->
		<el-dialog class="mydialog" title="回款详情" v-model="paymentDialogVisible" width="1000px" :close-on-click-modal="false">
			<el-tabs v-model="paymentActiveTab">
				<!-- 基本信息 -->
				<el-tab-pane label="基本信息" name="basic">
					<el-descriptions :column="2" border>
						<el-descriptions-item label="回款编号">{{ currentPayment.number }}</el-descriptions-item>
						<el-descriptions-item label="客户名称">{{ viewOpportunity.customerName }}</el-descriptions-item>
						<el-descriptions-item label="所属商机">{{ viewOpportunity.name }}</el-descriptions-item>
						<el-descriptions-item
							label="回款金额">{{ formatAmount(currentPayment.money) }}</el-descriptions-item>
						<el-descriptions-item
							label="回款时间">{{ formatDateTime(currentPayment.returnTime) }}</el-descriptions-item>
						<el-descriptions-item label="回款方式">{{ currentPayment.returnType }}</el-descriptions-item>
						<el-descriptions-item
							label="创建时间">{{ formatDateTime(currentPayment.createTime) }}</el-descriptions-item>
						<el-descriptions-item label="备注说明" :span="2">
							<span style="white-space: pre-wrap">{{ currentPayment.remark || '无' }}</span>
						</el-descriptions-item>
						<!-- 附件信息 -->
						<el-descriptions-item label="回款单" :span="2">
							<el-link v-if="currentPayment.receiptFile" type="primary"
								@click="handleReceiptFilePreview({url:'/api/move/getOssFile?name='+ currentPayment.receiptFile})">
								查看回款单
							</el-link>
							<span v-else>无</span>
						</el-descriptions-item>
					</el-descriptions>
				</el-tab-pane>
				<!-- 跟进记录 -->
				<el-tab-pane label="跟进记录" name="followup">
					<div class="followup-header">
						<el-button type="primary" size="small" @click="handleAddFollowup1">
							<i class="el-icon-plus"></i> 添加跟进记录
						</el-button>
					</div>
					<el-timeline>
						<el-timeline-item v-for="(record, index) in followupRecords1" :key="index"
							:timestamp="formatDateTime(record.createTime)" :type="getFollowupType(record.type)"
							:hollow="record.type === 'other'" :color="getFollowupColor(record.type)">
							<el-card class="followup-card">
								<template #header>
									<div class="followup-header">
										<span class="followup-title">{{ record.subject }}</span>
										<el-tag size="small"
											:type="getFollowupType(record.type)">{{ getFollowupTypeText(record.type) }}</el-tag>
									</div>
								</template>
								<div class="followup-content">
									<div class="followup-info">
										<p><i class="el-icon-time"></i> 时间：{{ formatDateTime(record.startTime) }} -
											{{ formatDateTime(record.endTime) }}
										</p>
										<p><i class="el-icon-location"></i> 地点：{{ record.location || '未设置' }}</p>
										<p v-if="record.lng && record.lat">
											<i class="el-icon-map-location"></i> 坐标：{{ record.lng }}, {{ record.lat }}
										</p>
										<p><i class="el-icon-user"></i> 跟进人：{{ record.username }}</p>
									</div>
									<div class="followup-notes">
										<h4>跟进内容：</h4>
										<p>{{ record.notes }}</p>
									</div>
									<div v-if="record.photos && record.photos.length > 0" class="followup-photos">
										<h4>相关图片：</h4>
										<!-- <text>{{ record.photos[0] }}</text> -->
										<el-image v-for="(photo, photoIndex) in record.photos" :key="photoIndex"
											:src="photo" :preview-src-list="record.photos" fit="cover"
											class="followup-photo">
										</el-image>
									</div>
								</div>
							</el-card>
						</el-timeline-item>
					</el-timeline>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>

		<!-- 添加团队成员对话框 -->
		<el-dialog class="mydialog" title="添加团队成员" v-model="teamMemberDialogVisible" width="500px">
			<el-card shadow="never">
				<el-form :model="teamMemberForm" :rules="teamMemberRules" ref="teamMemberForm" label-width="auto">
					<el-form-item label="成员" prop="userId">
						<el-col :span="20">
							<el-select v-model="teamMemberForm.userId" placeholder="请选择成员" filterable remote
								:remote-method="handleUserSearch" :loading="userSearchLoading">
								<el-option v-for="item in userOptions" :key="item.id" :label="item.username"
									:value="item.id">
								</el-option>
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="角色" prop="power">
						<el-col :span="20">
							<el-select v-model="teamMemberForm.power" placeholder="请选择角色">
								<el-option label="销售" :value="0"></el-option>
								<el-option label="技术支持" :value="1"></el-option>
								<el-option label="其他" :value="2"></el-option>
							</el-select>
						</el-col>
					</el-form-item>
				</el-form>
			</el-card>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="teamMemberDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitTeamMember">确 定</el-button>
				</span>
			</template>
		</el-dialog>
		<el-dialog class="mydialog" title="导入报价" v-model="importQuotationVisible" width="600px">
			<el-card shadow="never">
				<div class="upload-demo" style="width: 100%;" @click="openFileDialog" @dragenter="handleDragOver"
					@dragover="handleDragOver" @dragleave="handleDragLeave" @drop="handleDrop">
					<div tabindex="0" class="el-upload el-upload--text" style="width: 100%;">
						<div class="el-upload-dragger" style="width: 100%;"><el-icon
								class="el-icon--upload"><upload-filled /></el-icon>
							<div class="el-upload__text">将文件拖到此处，或<em>点击导入</em></div>
							<div class="el-upload__text">支持 .xlsx, .xls 格式，且不超过500kb</div>
						</div><input type="file" ref="fileInput" accept=".xlsx,.xls" class="el-upload__input"
							@change="handleFileChange" />
					</div>
				</div>
			</el-card>
		</el-dialog>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import * as XLSX from 'xlsx/xlsx.mjs'
	import {
		getOpportunityList,
		addOpportunity,
		updateOpportunity,
		deleteOpportunity,
		addActivities,
		getExportOffer
	} from '@/api/opportunity'
	import {
		getCustomerList
	} from '@/api/customer'
	import {
		getBusActivitiesList,
		addApproval,
		submitApproval,
		withdrawApproval,
		getExamineTem,
		getExamineFlowDetail
	} from '@/api/approval'
	import {
		getOpportunityQuotations,
		addQuotation,
		updateQuotation,
		withdrawQuotation,
		getExamineList,
		submitQuotation
	} from '@/api/quotation'
	import {
		getOpportunityContracts,
		updateContract,
		withdrawContract,
		submitContract,
		createContract
	} from '@/api/contract'
	import {
		getOpportunityPayments,
		updatePayment,
		withdrawPayment,
		submitPayment,
		createPayment,
		searchCustomers,
		deletePayment
	} from '@/api/payment'
	import {
		getProductList,
		addProduct
	} from '@/api/product'
	import {
		ElMessage
	} from 'element-plus'
	import {
		deleteContract
	} from '@/api/contract'
	import dayjs from 'dayjs'
	import {
		getTeamList,
		addTeamMember,
		removeTeamMember,
		searchUsers
	} from '@/api/team'

	import BusActivities from '@/components/BusActivities.vue'

	export default {
		name: 'OpportunityManagement',
		components: {
			BusActivities
		},
		computed: {
			...mapState({
				username: state => state.user.username,
				userId: state => state.user.id,
				isBoss: state => state.user.isBoss
			})
		},
		data() {
			return {
				startendTime: [new Date(), new Date()],
				loading: false,
				isLoading: false,
				importQuotationVisible: false,
				importQuotationTitle: '导入报价',
				followupFormTitle: '',
				// 筛选表单
				filterForm: {
					name: '',
					stage: '',
					type: 'all'
				},
				submitDialogVisible: false,
				submitForm1: {
					examineName: '',
					temId: ''
				},
				submitRules: {
					examineName: [{
						required: true,
						message: '请输入审批名称',
						trigger: 'blur'
					}],
					temId: [{
						required: true,
						message: '请选择审批模板',
						trigger: 'change'
					}]
				},
				// 分页相关
				currentPage: 1,
				pageSize: 10,
				total: 0,

				// 商机列表
				opportunityList: [],
				customerList: [],

				// 商机表单对话框
				dialogVisible: false,
				dialogTitle: '添加商机',
				opportunityForm: {
					name: '',
					customerId: '',
					expectedAmount: 0,
					stage: 0,
					expectedCloseDate: '',
					description: ''
				},
				rules: {
					name: [{
						required: true,
						message: '请输入商机名称',
						trigger: 'blur'
					}],
					customerId: [{
						required: true,
						message: '请选择客户',
						trigger: 'change'
					}],
					expectedAmount: [{
						required: true,
						message: '请输入预计金额',
						trigger: 'blur'
					}],
					stage: [{
						required: true,
						message: '请选择商机状态',
						trigger: 'change'
					}],
					expectedCloseDate: [{
						required: true,
						message: '请选择预计成交日期',
						trigger: 'change'
					}]
				},

				// 商机详情对话框
				viewDialogVisible: false,
				viewOpportunity: {},
				activeTab: 'basic',

				// 跟进记录相关
				followupDialogVisible: false,
				followupRecords: [],
				followupRecords0: [],
				followupForm: {
					businessId: '',
					businessName: '',
					customerId: '',
					customerName: '',
					subject: '',
					type: 'phone',
					startTime: '',
					endTime: '',
					location: '',
					lng: '',
					lat: '',
					pic: '',
					notes: ''
				},
				followupRules: {
					subject: [{
						required: true,
						message: '请输入跟进主题',
						trigger: 'blur'
					}],
					type: [{
						required: true,
						message: '请选择跟进方式',
						trigger: 'change'
					}],
					classify: [{
						required: true,
						message: '请选择跟进类型',
						trigger: 'change'
					}],
					notes: [{
						required: true,
						message: '请输入跟进内容',
						trigger: 'blur'
					}],
					startTime: [{
						required: true,
						message: '请选择开始时间',
						trigger: 'change'
					}],
					endTime: [{
						required: true,
						message: '请选择结束时间',
						trigger: 'change'
					}],
					// location: [{ required: true, message: '请输入地点', trigger: 'blur' }],
					// lng: [{ required: true, message: '请输入经度', trigger: 'blur' }],
					// lat: [{ required: true, message: '请输入纬度', trigger: 'blur' }],
					// pic: [{ required: true, message: '请上传照片', trigger: 'change' }]
				},

				// 文件上传相关
				previewVisible: false,
				previewUrl: '',
				uploadHeaders: {
					Authorization: localStorage.getItem('token') || ''
				},
				fileList: [],

				// 报价相关
				quotationList: [],
				quotationDialogVisible: false,
				quotationActiveTab: 'basic',
				currentQuotation: {},
				quotationFormVisible: false,
				quotationFormTitle: '新建报价',
				quotationForm: {
					name: '',
					customerName: '',
					offerPrice: 0,
					cost: 0,
					profit: 0,
					remark: '',
					businessId: '',
					customerId: '',
					products: []
				},
				quotationRules: {
					customerName: [{
						required: true,
						message: '请输入客户名称',
						trigger: 'blur'
					}],
					businessName: [{
						required: true,
						message: '请输入商机名称',
						trigger: 'blur'
					}],
					businessId: [{
						required: true,
						message: '请选择商机',
						trigger: 'change'
					}],
					cost: [{
						required: true,
						message: '请输入成本价',
						trigger: 'blur'
					}],
					profit: [{
						required: true,
						message: '请输入利润',
						trigger: 'blur'
					}],
					unitPrice: [{
						required: true,
						message: '请输入单价',
						trigger: 'blur'
					}],
					offerTime: [{
						required: true,
						message: '请选择报价时间',
						trigger: 'change'
					}],
					name: [{
						required: true,
						message: '请输入报价编号',
						trigger: 'blur'
					}],
					offerPrice: [{
						required: true,
						message: '请输入报价金额',
						trigger: 'blur'
					}]
				},

				// 产品选择相关
				productSelectorVisible: false,
				productSearchKeyword: '',
				productList: [],
				selectedProducts: [],
				filteredProducts: [],
				productCurrentPage: 1,
				productPageSize: 10,
				productTotal: 0,
				customerOptions: [],
				customerSearchLoading: false,
				addProductVisible: false,
				productForm: {
					name: '',
					specification: '',
					unit: '',
					unitPrice: 0,
					costPrice: 0,
					remark: ''
				},
				productRules: {
					name: [{
						required: true,
						message: '请输入产品名称',
						trigger: 'blur'
					}],
					specification: [{
						required: true,
						message: '请输入规格型号',
						trigger: 'blur'
					}],
					unit: [{
						required: true,
						message: '请输入单位',
						trigger: 'blur'
					}],
					unitPrice: [{
						required: true,
						message: '请输入单价',
						trigger: 'blur'
					}],
					costPrice: [{
						required: true,
						message: '请输入成本价',
						trigger: 'blur'
					}]
				},

				// 审批相关
				approvalList: [],
				viewApprovalDialogVisible: false,
				activeApprovalTab: 'basic',
				viewApproval: {},
				approvalFormTitle: '新建审批',
				approvalFormVisible: false,
				approvalForm: {
					examineName: '',
					examineTemId: '',
					oaType: 'quotation',
					businessId: '',
					businessName: '',
					customerId: '',
					customerName: '',
					description: ''
				},
				approvalRules: {
					examineName: [{
						required: true,
						message: '请输入审批名称',
						trigger: 'blur'
					}],
					examineTemId: [{
						required: true,
						message: '请选择审批模板',
						trigger: 'change'
					}],
					oaType: [{
						required: true,
						message: '请选择审批类型',
						trigger: 'change'
					}],
					description: [{
						required: true,
						message: '请输入审批说明',
						trigger: 'blur'
					}]
				},
				templateList: [], // 审批模板列表

				// 合同相关
				contractList: [],

				// 回款相关
				paymentList: [],

				// 合同相关
				contractFormTitle: '新建合同',
				contractFormVisible: false,
				contractForm: {
					contractNumber: '',
					contractName: '',
					customerId: '',
					customerName: '',
					businessId: '',
					businessName: '',
					totalAmount: 0,
					signedDate: '',
					startDate: '',
					endDate: '',
					paymentTerms: '',
					notes: '',
					contractFile: '',
					status: 9 // 默认状态为待提交
				},
				contractRules: {
					contractNumber: [{
						required: true,
						message: '请输入合同编号',
						trigger: 'blur'
					}],
					contractName: [{
						required: true,
						message: '请输入合同名称',
						trigger: 'blur'
					}],
					totalAmount: [{
						required: true,
						message: '请输入合同金额',
						trigger: 'blur'
					}],
					signedDate: [{
						required: true,
						message: '请选择签订日期',
						trigger: 'change'
					}],
					startDate: [{
						required: true,
						message: '请选择生效日期',
						trigger: 'change'
					}],
					endDate: [{
						required: true,
						message: '请选择到期日期',
						trigger: 'change'
					}],
					paymentTerms: [{
						required: true,
						message: '请输入合同内容',
						trigger: 'blur'
					}],
					contractFile: [{
						required: true,
						message: '请上传合同文件',
						trigger: 'change'
					}]
				},
				contractDialogVisible: false,
				contractActiveTab: 'basic',
				currentContract: {},
				contractApprovalList: [],
				contractSubmitDialogVisible: false,
				contractSubmitForm: {
					examineName: '',
					temId: ''
				},

				// 回款相关
				paymentFormTitle: '新建回款',
				paymentFormVisible: false,
				paymentForm: {
					number: '',
					customerId: '',
					customerName: '',
					businessId: '',
					businessName: '',
					money: 0,
					returnTime: '',
					returnType: '',
					remark: ''
				},
				paymentRules: {
					number: [{
						required: true,
						message: '请输入回款编号',
						trigger: 'blur'
					}],
					money: [{
						required: true,
						message: '请输入回款金额',
						trigger: 'blur'
					}],
					returnTime: [{
						required: true,
						message: '请选择回款时间',
						trigger: 'change'
					}],
					returnType: [{
						required: true,
						message: '请选择回款方式',
						trigger: 'change'
					}],
					contractId: [{
						required: true,
						message: '请选择合同',
						trigger: 'change'
					}]
				},
				paymentDialogVisible: false,
				paymentActiveTab: 'basic',
				currentPayment: {},
				paymentApprovalList: [],
				paymentSubmitDialogVisible: false,
				paymentSubmitForm: {
					examineName: '',
					temId: ''
				},

				// 合同文件上传相关
				contractFileList: [],

				// 团队明细
				teamList: [],
				teamMemberDialogVisible: false,
				teamMemberForm: {
					userId: '',
					role: '',
					businessId: ''
				},
				teamMemberRules: {
					userId: [{
						required: true,
						message: '请选择成员',
						trigger: 'change'
					}],
					power: [{
						required: true,
						message: '请选择角色',
						trigger: 'change'
					}]
				},
				userOptions: [],
				userSearchLoading: false,
			}
		},
		created() {
			// this.userId = this.$store.getters.userInfo.id
			// console.log(this.userId);

			this.fetchData()
			this.fetchCustomers()
			this.fetchApprovalTemplates()
		},
		methods: {
			canEdit(row) {
				return this.userId === row.userId || this.isBoss === 1
			},
			// 打开文件选择对话框
			openFileDialog() {
				this.$refs.fileInput.click();
			},

			// 处理文件选择
			handleFileSelect(event) {
				const file = event.target.files[0];
				if (file) {
					this.processExcelFile(file);
				}
			},

			// 处理拖拽事件
			handleDragOver(event) {
				event.preventDefault();
				this.isDragging = true;
			},

			handleDragLeave() {
				this.isDragging = false;
			},

			handleDrop(event) {
				event.preventDefault();
				this.isDragging = false;

				const file = event.dataTransfer.files[0];
				if (file) {
					this.processExcelFile(file);
				}
			},
			handleFileChange(event) {
				const target = event.target;
				if (!target.files.length) return
				const file = target.files[0]
				this.processExcelFile(file)
				target.value = '' // 重置input，允许重复选择同一文件
			},
			processExcelFile(file) {
				console.log(file);
				//const file = event.target.files[0];
				const fileType = file.name.split('.').pop().toLowerCase();
				//console.log('fileType', fileType)
				if (!['xlsx', 'xls'].includes(fileType)) {
					ElMessage.error('请选择有效的Excel文件（.xlsx, .xls）');
					return;
				}
				// 读取文件
				const reader = new FileReader();
				reader.readAsArrayBuffer(file);
				reader.onload = (e) => {
					try {
						const data = e.target.result;
						const workbook = XLSX.read(data, {
							type: 'array'
						});
						const sheetName = workbook.SheetNames[0];
						const sheet = workbook.Sheets[sheetName];
						const jsonData = XLSX.utils.sheet_to_json(sheet, {
							defval: "",
							raw: false
						});
						//console.log(jsonData);
						// 处理导入的数据
						if (jsonData && jsonData.length > 0) {
							const products = this.transformExcelData(jsonData)

							if (products && products.length > 0) {
								this.quotationForm.products = products;
								this.calculateTotalAmount();
								ElMessage.success('导入成功');
								this.importQuotationVisible = false;
							} else {
								ElMessage.error('导入的文件没有数据');
							}
						} else {
							ElMessage.warning('导入的文件没有数据');
						}
					} catch (error) {
						console.error('文件解析错误:', error);
						ElMessage.error('文件解析失败，请确保文件格式正确');
					}
				};

				reader.onerror = () => {
					ElMessage.error('文件读取失败');
				};
				reader.readAsArrayBuffer(file.raw);
			},
			transformExcelData(excelData) {
				const FIELD_MAPPING = {
					"产品名称": "name",
					"产品规格": "specification",
					"单位": "unit",
					"数量": "quantity",
					"单价": "unitPrice",
					"成本价": "costPrice",
					"总价": "amount",
					"备注": "remark"
				};
				return excelData
					.map(item => {
						// 检查必填字段 - 产品名称和单价
						const hasName = item["产品名称"] !== undefined || item.name !== undefined;
						const hasPrice = item["单价"] !== undefined || item.unitPrice !== undefined;

						if (!hasName || !hasPrice) {
							return null; // 跳过缺少必填字段的数据
						}

						// 构建标准化对象
						const standardizedItem = {};

						// 遍历映射关系，处理每个字段
						Object.entries(FIELD_MAPPING).forEach(([chineseField, englishField]) => {
							// 优先取中文字段，没有则取英文字段
							const value = item[chineseField] ?? item[englishField];

							// 特殊处理数值型字段
							if (['quantity', 'unitPrice', 'costPrice', 'amount'].includes(englishField)) {
								standardizedItem[englishField] = englishField === 'quantity' ?
									Number(value) || 1 // 数量默认1
									:
									Number(value) || 0; // 其他数值默认0
							} else {
								standardizedItem[englishField] = value || '';
							}
						});

						return standardizedItem;
					})
					.filter(item => item !== null); // 过滤无效数据
			},
			handleImportQuotationError(error) {
				console.log(error)
			},

			async fetchApprovalTemplates() {
				try {
					const res = await getExamineTem({
						current: 1,
						size: 1000
					})
					this.approvalTemplateList = res.data.records
				} catch (error) {
					console.error('获取审批模板列表失败:', error)
					// ElMessage.error('获取审批模板列表失败')
				}
			},
			formatDateTime(date) {
				if (!date) return ''
				return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
			},
			async handleDeleteContract(row) {
				try {
					await this.$confirm('确认删除该合同吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					await deleteContract({
						id: row.id
					})
					this.$message.success('删除成功')
					this.fetchContractList(this.viewOpportunity.id)
				} catch (error) {
					if (error !== 'cancel') {
						console.error('删除合同失败:', error)
						this.$message.error('删除失败')
					}
				}
			},
			importQuotation() {
				// 清理上次导入的文件和状态
				this.selectedFile = null
				this.fileList = []
				this.error = null
				this.isDragging = false
				if (this.quotationForm && Array.isArray(this.quotationForm.products)) {
					this.quotationForm.products = []
				}
				if (this.$refs.fileInput) this.$refs.fileInput.value = ''
				this.importQuotationVisible = true
				this.importQuotationTitle = '导入报价'
			},
			async handleDeletePayment(row) {
				try {
					await this.$confirm('确认删除该回款记录吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					await deletePayment({
						id: row.id
					})
					this.$message.success('删除成功')
					this.fetchPaymentList(this.viewOpportunity.id)
				} catch (error) {
					if (error !== 'cancel') {
						console.error('删除回款记录失败:', error)
						this.$message.error('删除失败')
					}
				}
			},
			formatDate(date) {
				if (!date) return ''
				return dayjs(date).format('YYYY-MM-DD')
			},
			formatAmount(amount) {
				return amount ? amount.toLocaleString('zh-CN', {
					minimumFractionDigits: 2
				}) : '0.00'
			},
			getStatusTypeOffer(status) {
				const statusMap = {
					0: 'primary',
					1: 'success',
					2: 'danger',
					9: 'info',
					4: 'warning'
				}
				return statusMap[status] || 'info'
			},
			getStatusTextOffer(status) {
				const statusMap = {
					0: '审核中',
					1: '已审核',
					2: '已拒绝',
					9: '待提交',
					4: '已撤回'
				}
				return statusMap[status] || status
			},
			getStatusType(status) {
				const statusMap = {
					0: 'info',
					1: 'warning',
					2: 'primary',
					3: 'success',
					4: 'success',
					5: 'danger'
				}
				return statusMap[status] || 'info'
			},
			getStatusText(status) {
				const statusMap = {
					0: '初步接触',
					1: '需求确认',
					2: '方案报价',
					3: '商务谈判',
					4: '赢单',
					5: '输单'
				}
				return statusMap[status] || status
			},
			async fetchData() {
				try {
					const params = {
						current: this.currentPage,
						size: this.pageSize,
						...this.filterForm
					}
					const res = await getOpportunityList(params)
					this.opportunityList = res.data.records
					this.total = res.data.total
				} catch (error) {
					console.error('获取商机列表失败:', error)
				}
			},
			async fetchCustomers() {
				try {
					const res = await getCustomerList({
						current: 1,
						size: 1000
					})
					this.customerList = res.data.records
				} catch (error) {
					console.error('获取客户列表失败:', error)
				}
			},
			handleSearch() {
				this.currentPage = 1
				this.fetchData()
			},
			resetForm() {
				this.filterForm = {
					name: '',
					stage: '',
					type: 'all'
				}
				this.handleSearch()
			},
			async handleExportQuotation(row) {
				// console.log(row)
				// getExportOffer({id: row.id})
				let offerid = {
					id: row.id
				}

				await getExportOffer(offerid)

			},
			handleSizeChange(val) {
				this.pageSize = val
				this.fetchData()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.fetchData()
			},
			async confirmSubmit() {
				try {
					await this.$refs.submitFormRef.validate()
					this.submitForm1.status = 0
					await submitQuotation(this.submitForm1)
					this.$message.success('提交成功')
					this.submitDialogVisible = false
					this.fetchQuotationList(this.viewOpportunity.id)
				} catch (error) {
					if (error !== 'cancel') {
						console.error('提交报价失败:', error)
						this.$message.error('提交失败')
					}
				}
			},
			handleAddOpportunity() {
				this.dialogTitle = '添加商机'
				this.opportunityForm = {
					name: '',
					customerId: '',
					expectedAmount: 0,
					stage: 0,
					expectedCloseDate: '',
					description: ''
				}
				this.dialogVisible = true
			},
			handleEdit(row) {
				this.dialogTitle = '编辑商机'
				this.opportunityForm = {
					...row
				}
				this.dialogVisible = true
			},
			async handleView(row) {
				this.viewOpportunity = {
					...row
				}
				this.viewDialogVisible = true
				this.activeTab = 'basic'
				await this.fetchFollowupRecords(row.id)
				await this.fetchQuotationList(row.id)
				await this.fetchContractList(row.id)
				await this.fetchPaymentList(row.id)
				await this.fetchTeamList(row.id) // 添加这一行
			},
			async handleDelete(row) {
				try {
					await this.$confirm('确认删除该商机吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					await deleteOpportunity(row.id)
					this.$message.success('删除成功')
					this.fetchData()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('删除商机失败:', error)
					}
				}
			},
			async submitForm() {
				try {
					await this.$refs.opportunityForm.validate()
					if (this.opportunityForm.id) {
						await updateOpportunity(this.opportunityForm)
						this.$message.success('更新成功')
					} else {
						await addOpportunity(this.opportunityForm)
						this.$message.success('添加成功')
					}
					this.dialogVisible = false
					this.fetchData()
				} catch (error) {
					console.error('提交表单失败:', error)
				}
			},
			// 获取跟进记录
			async fetchFollowupRecords(opportunityId) {
				try {
					const res = await getBusActivitiesList({
						businessId: opportunityId,
						classify: 0
					})
					// 使用Vue的响应式更新方式
					this.followupRecords0 = res.data.map(record => ({
						...record,
						photos: record.pic ? ["/api/move/getMinRes?name=" + record.pic] : []
					}))
					// 使用Vue的响应式更新方式
					// this.followupRecords0 = this.followupRecords.filter(record => record.classify === 0)
					// this.followupRecords1 = this.followupRecords.filter(record => record.classify === 1)

					// 强制更新视图
					this.$nextTick(() => {
						this.$forceUpdate()
					})
				} catch (error) {
					console.error('获取跟进记录失败:', error)
					ElMessage.error('获取跟进记录失败')
				}
			},
			// 获取报价列表
			async fetchQuotationList(opportunityId) {
				try {
					const res = await getOpportunityQuotations({
						businessId: opportunityId
					})
					this.quotationList = res.data
				} catch (error) {
					console.error('获取报价列表失败:', error)
				}
			},
			// 获取合同列表
			async fetchContractList(opportunityId) {
				try {
					const res = await getOpportunityContracts({
						businessId: opportunityId
					})
					this.contractList = res.data
				} catch (error) {
					console.error('获取合同列表失败:', error)
				}
			},
			// 获取回款列表
			async fetchPaymentList(opportunityId) {
				try {
					const res = await getOpportunityPayments({
						businessId: opportunityId
					})
					this.paymentList = res.data
				} catch (error) {
					console.error('获取回款列表失败:', error)
				}
			},
			// 添加跟进记录
			handleAddFollowup() {
				this.resetFollowupForm()
				this.followupFormTitle = '添加跟进记录'
				this.followupForm.businessId = this.viewOpportunity.id
				this.followupForm.customerId = this.viewOpportunity.customerId
				this.followupForm.businessName = this.viewOpportunity.name
				this.followupForm.classify = 0
				this.followupForm.customerName = this.viewOpportunity.customerName
				this.followupDialogVisible = true
			},
			handleAddFollowup1() {
				this.resetFollowupForm()
				this.followupFormTitle = '添加回款跟进记录'
				this.followupForm.businessId = this.viewOpportunity.id
				this.followupForm.customerId = this.viewOpportunity.customerId
				this.followupForm.businessName = this.viewOpportunity.name
				this.followupForm.receivablesId = this.currentPayment.id
				this.followupForm.receivablesName = this.currentPayment.number
				this.followupForm.classify = 1
				this.followupForm.customerName = this.viewOpportunity.customerName
				this.followupDialogVisible = true
			},
			// 提交跟进记录
			async submitFollowup() {
				this.followupForm.startTime = this.formatDateTime(this.startendTime[0])
				this.followupForm.endTime = this.formatDateTime(this.startendTime[1])
				try {
					await this.$refs.followupForm.validate()
					await addActivities(this.followupForm)
					this.$message.success('添加成功')
					this.followupDialogVisible = false

					// 重置表单
					this.resetFollowupForm()

					// 重新获取跟进记录
					await this.fetchFollowupRecords(this.viewOpportunity.id)

					// 强制更新视图
					this.$nextTick(() => {
						this.$forceUpdate()
					})
				} catch (error) {
					console.error('提交跟进记录失败:', error)
					ElMessage.error('提交跟进记录失败')
				}
			},
			// 获取跟进类型样式
			getFollowupType(type) {
				const typeMap = {
					'电话沟通': 'primary',
					'邮件往来': 'success',
					'实地拜访': 'warning',
					'其他方式': 'info'
				}
				return typeMap[type] || 'info'
			},
			// 获取跟进类型文本
			getFollowupTypeText(type) {
				const typeMap = {
					'电话沟通': '电话沟通',
					'邮件往来': '邮件往来',
					'实地拜访': '实地拜访',
					'其他方式': '其他方式'
				}
				return typeMap[type] || '未知类型'
			},
			async handleCustomerSearch(query) {
				if (query) {
					this.customerSearchLoading = true
					try {
						const res = await searchCustomers({
							name: query
						})
						this.customerOptions = res.data
					} catch (error) {
						console.error('搜索客户失败:', error)
						ElMessage.error('搜索客户失败')
					} finally {
						this.customerSearchLoading = false
					}
				} else {
					this.customerOptions = []
				}
			},
			// 获取跟进类型颜色
			getFollowupColor(type) {
				const colorMap = {
					phone: '#409EFF',
					email: '#67C23A',
					visit: '#E6A23C',
					other: '#909399'
				}
				return colorMap[type] || '#909399'
			},
			// 获取报价状态样式
			getQuotationStatusType(status) {
				const typeMap = {
					0: 'info', // 草稿
					1: 'warning', // 待审批
					2: 'success', // 已通过
					3: 'danger' // 已拒绝
				}
				return typeMap[status] || 'info'
			},
			// 获取报价状态文本
			getQuotationStatusText(status) {
				const textMap = {
					0: '草稿',
					1: '待审批',
					2: '已通过',
					3: '已拒绝'
				}
				return textMap[status] || '未知'
			},
			// 获取合同状态样式
			getContractStatusType(status) {
				const typeMap = {
					0: 'warning', // 审核中
					1: 'success', // 已生效
					2: 'danger', // 已终止
					9: 'info' // 待提交
				}
				return typeMap[status] || 'info'
			},
			// 获取合同状态文本
			getContractStatusText(status) {
				const textMap = {
					0: '审核中',
					1: '已生效',
					2: '已终止',
					9: '待提交'
				}
				return textMap[status] || '未知'
			},
			// 获取回款状态样式
			getPaymentStatusType(status) {
				const typeMap = {
					0: 'info', // 待确认
					1: 'success', // 已确认
					2: 'danger' // 已驳回
				}
				return typeMap[status] || 'info'
			},
			// 获取回款状态文本
			getPaymentStatusText(status) {
				const textMap = {
					0: '未回款',
					1: '已回款',
					2: '已拒绝'
				}
				return textMap[status] || '未知'
			},
			// 查看报价详情
			async handleViewQuotation(row) {
				this.currentQuotation = {
					...row
				}
				this.quotationDialogVisible = true
				this.quotationActiveTab = 'basic'
				await this.fetchApprovalList(row.id)
			},
			// 查看合同详情
			async handleViewContract(row) {
				this.currentContract = {
					...row
				}
				this.contractDialogVisible = true
				this.contractActiveTab = 'basic'
				await this.fetchContractApprovalList(row.id)
			},
			// 查看回款详情
			async handleViewPayment(row) {
				this.currentPayment = {
					...row
				}
				this.paymentDialogVisible = true
				this.paymentActiveTab = 'basic'
				let a = await getBusActivitiesList({
					businessId: row.businessId,
					classify: 1,
					receivablesId: row.id
				})
				this.followupRecords1 = a.data
				//  this.fetchPaymentApprovalList(row.id)
			},
			handlePictureCardPreview(file) {
				this.previewUrl = file.url
				this.previewVisible = true
			},
			handleRemove() {
				// 释放临时URL
				if (this.fileList.length > 0) {
					URL.revokeObjectURL(this.fileList[0].url)
				}
				this.fileList = []
				this.followupForm.pic = ''
			},
			handleUploadSuccess(response, file) {
				const imageUrl = response.data
				console.log('Upload success, imageUrl:', imageUrl, file)
				// 更新表单数据
				this.followupForm.pic = imageUrl

				// 清空之前的文件列表
				if (this.fileList.length > 0) {
					// 释放之前的临时URL
					URL.revokeObjectURL(this.fileList[0].url)
				}
				this.fileList = []

				// 创建临时文件URL用于预览
				const tempUrl = URL.createObjectURL(file.raw)
				this.fileList = [{
					name: file.name,
					url: tempUrl,
					status: 'success',
					raw: file.raw
				}]
			},
			handleUploadError(error) {
				console.error('Upload error:', error)
			},
			beforeUpload(file) {
				// 更新 token，以防 token 过期
				this.uploadHeaders.Authorization = localStorage.getItem('token') || ''

				const isImage = file.type.startsWith('image/')
				const isLt2M = file.size / 1024 / 1024 < 2

				if (!isImage) {
					this.$message.error('只能上传图片文件!')
					return false
				}
				if (!isLt2M) {
					this.$message.error('图片大小不能超过 2MB!')
					return false
				}

				// 清空之前的文件列表
				// this.fileList = []
				// // 创建临时文件URL用于预览
				// const tempUrl = URL.createObjectURL(file)
				// this.fileList = [{ name: file.name, url: tempUrl, status: 'success' }]
				return true
			},
			handleExceed() {
				this.$message.warning('只能上传一张图片')
			},
			// 重置跟进记录表单
			resetFollowupForm() {
				this.followupForm = {
					businessId: '',
					businessName: '',
					customerId: '',
					customerName: '',
					subject: '',
					type: '',
					startTime: '',
					endTime: '',
					location: '',
					lng: '',
					lat: '',
					pic: '',
					notes: ''
				}
				// 释放临时URL
				if (this.fileList.length > 0) {
					URL.revokeObjectURL(this.fileList[0].url)
				}
				this.fileList = []
				if (this.$refs.followupForm) {
					this.$refs.followupForm.resetFields()
				}
			},
			beforeDestroy() {
				// 组件销毁时释放所有临时URL
				if (this.fileList.length > 0) {
					URL.revokeObjectURL(this.fileList[0].url)
				}
			},
			handleQuotationClick(row) {
				// 跳转到报价管理页面，并携带参数
				this.$router.push({
					path: '/quotation',
					query: {
						name: row.name, // 添加报价名称参数

					}
				})
			},
			handleContractClick(row) {
				// 跳转到合同管理页面，并携带参数
				this.$router.push({
					path: '/contract',
					query: {
						number: row.contractNumber // 添加合同编号参数
					}
				})
			},
			handlePaymentClick(row) {
				// 跳转到回款管理页面，并携带参数
				this.$router.push({
					path: '/payment',
					query: {
						number: row.number // 添加回款编号参数
					}
				})
			},
			handleAddQuotation() {
				this.quotationFormTitle = '新建报价'
				this.quotationForm = {
					paymentTerms: '',
					remark: '',
					opportunityName: '',
					offerPrice: 0,
					cost: 0,
					profit: 0,
					offerTime: '',
					examineTemId: '',
					name: '',
					customerName: this.viewOpportunity.customerName,
					businessId: this.viewOpportunity.id,
					customerId: this.viewOpportunity.customerId,
					businessName: this.viewOpportunity.name,
					products: []
				}
				this.quotationFormVisible = true
			},
			handleEditQuotation(row) {
				this.quotationFormTitle = '编辑报价'
				this.quotationForm = {
					id: row.id,
					name: row.name,
					customerId: row.customerId,
					cost: row.cost,
					offerPrice: row.offerPrice,
					profit: row.profit,
					offerTime: row.offerTime,
					customerName: row.customerName,
					// validUntil: row.validUntil,
					products: row.businessProducts,
					paymentTerms: row.paymentTerms,
					deliveryTime: row.deliveryTime,
					remark: row.remark,
					businessId: row.businessId,
					businessName: row.businessName,
					// examineTemId: row.examineTemId
				}
				row.businessProducts.forEach((product, index) => {
					this.quotationForm.products[index].name = product.productName
					this.quotationForm.products[index].specification = product.specification
					this.quotationForm.products[index].unit = product.unit
					this.quotationForm.products[index].unitPrice = product.productPrice
					// this.quotationForm.products[index].amount = product.unitPrice * product.quantity
					this.quotationForm.products[index].costPrice = product.costPrice
					this.quotationForm.products[index].productId = product.productId
					this.quotationForm.products[index].quantity = product.quantity
					this.quotationForm.products[index].remark = product.remark
					this.quotationForm.products[index].quantity = product.productNum
					this.quotationForm.products[index].amount = product.amount
				})

				this.quotationFormVisible = true
			},
			async submitQuotationForm() {
				try {
					await this.$refs.quotationForm.validate()
					if (this.quotationForm.id) {
						await updateQuotation(this.quotationForm)
						this.$message.success('更新成功')
					} else {
						await addQuotation(this.quotationForm)
						this.$message.success('创建成功')
					}
					this.quotationFormVisible = false
					await this.fetchQuotationList(this.viewOpportunity.id)
				} catch (error) {
					console.error('提交报价表单失败:', error)
				}
			},
			async fetchApprovalList(quotationId) {
				try {
					const params = quotationId ? {
						offerId: quotationId
					} : {
						offerId: this.currentQuotation.id
					}
					const res = await getExamineList(params)
					this.approvalList = res.data
				} catch (error) {
					console.error('获取审批列表失败:', error)
				}
			},
			async handleViewApproval(row) {
				this.viewApproval = {
					...row
				}
				this.handleApprove(row)
				this.viewApprovalDialogVisible = true
				this.activeApprovalTab = 'basic'
			},
			async handleApprove(row) {
				console.log(row)
				try {
					const res = await getExamineFlowDetail({
						id: row.id
					})
					console.log(res)
					this.viewApproval.process = res.data
					res.data.forEach(item => {
						if (item.userId === this.$store.state.user.id) {
							this.currentApproval = item
							this.approvalForm = {
								...item,
								ccUsers: []
							}
							this.approvalDialogVisible = true
						}
					})
				} catch (error) {
					console.error('获取审批流程失败:', error)
					this.$message.error('获取审批流程失败')
				}
			},
			async fetchApprovalProcess(approvalId) {
				try {
					// TODO: 调用获取审批流程API
					console.log('获取审批流程:', approvalId)
					// 模拟API调用
					this.approvalProcessList = []
				} catch (error) {
					console.error('获取审批流程失败:', error)
				}
			},
			getApprovalStatusType(status) {
				const typeMap = {
					0: 'warning', // 待审批
					1: 'success', // 已通过
					2: 'danger', // 已拒绝
					'-1': 'info', // 未撤回
					4: 'info' // 已撤销
				}
				return typeMap[status] || 'info'
			},
			getApprovalStatusText(status) {
				const textMap = {
					0: '待审批',
					1: '已通过',
					2: '已拒绝',
					'-1': '未开始',
					4: '已撤销'
				}
				return textMap[status] || '未知'
			},
			getApprovalStatusType1(status) {
				const typeMap = {
					1: 'warning', // 待审批
					3: 'success', // 已通过
					2: 'danger', // 已拒绝
					'-1': 'info', // 未撤回
					4: 'info' // 已撤销
				}
				return typeMap[status] || 'info'
			},
			getApprovalStatusText1(status) {
				const textMap = {
					1: '审批中',
					3: '已通过',
					2: '已拒绝',
					'-1': '未开始',
					4: '已撤销'
				}
				return textMap[status] || '未知'
			},
			async handleSubmitQuotation(row) {
				try {
					if (row.status === 0) {
						// 撤回审批
						await this.$confirm('确认撤回该报价的审批吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						})
						await withdrawQuotation({
							offerId: row.id
						})
						this.$message.success('撤回成功')
					} else {
						// 提交审批
						// 如果是未审核状态，执行提交审批操作
						this.submitForm1 = row
						this.submitForm1 = {
							id: row.id,
							name: row.name,
							customerId: row.customerId,
							cost: row.cost,
							offerPrice: row.offerPrice,
							profit: row.profit,
							offerTime: row.offerTime,
							products: row.businessProducts,
							paymentTerms: row.paymentTerms,
							deliveryTime: row.deliveryTime,
							remark: row.remark,
							businessId: row.businessId,
							opportunityName: row.businessName,
						}
						row.businessProducts.forEach((product, index) => {
							this.submitForm1.products[index].name = product.productName
							this.submitForm1.products[index].specification = product.specification
							this.submitForm1.products[index].unit = product.unit
							this.submitForm1.products[index].unitPrice = product.productPrice
							this.submitForm1.products[index].amount = product.unitPrice * product.quantity
							this.submitForm1.products[index].costPrice = product.costPrice
							this.submitForm1.products[index].productId = product.productId
							this.submitForm1.products[index].quantity = product.quantity
							this.submitForm1.products[index].remark = product.remark
							this.submitForm1.products[index].quantity = product.productNum
							this.submitForm1.products[index].amount = product.amount
						})
						this.submitDialogVisible = true
					}
					await this.fetchQuotationList(this.viewOpportunity.id)
				} catch (error) {
					if (error !== 'cancel') {
						console.error('操作失败:', error)
					}
				}
			},
			showProductSelector() {
				this.productSelectorVisible = true
				this.productSearchKeyword = ''
				this.selectedProducts = []
				this.productCurrentPage = 1
				this.fetchProducts()
			},
			async fetchProducts() {
				try {
					const params = {
						current: this.productCurrentPage,
						size: this.productPageSize,
						name: this.productSearchKeyword
					}
					const res = await getProductList(params)
					this.productList = res.data.records
					this.filteredProducts = [...this.productList]
					this.productTotal = res.data.total
				} catch (error) {
					console.error('获取产品列表失败:', error)
				}
			},
			handleProductSearch() {
				this.productCurrentPage = 1
				this.fetchProducts()
			},
			handleProductSizeChange(val) {
				this.productPageSize = val
				this.fetchProducts()
			},
			handleProductCurrentChange(val) {
				this.productCurrentPage = val
				this.fetchProducts()
			},
			handleProductSelectionChange(selection) {
				this.selectedProducts = selection
			},
			confirmProductSelection() {
				if (this.selectedProducts.length === 0) {
					this.$message.warning('请选择产品')
					return
				}
				// 将选中的产品添加到报价明细中
				const newProducts = this.selectedProducts.map(product => ({
					id: product.id,
					name: product.name,
					specification: product.specification,
					unit: product.unit,
					unitPrice: product.unitPrice,
					costPrice: product.costPrice,
					quantity: 1,
					amount: product.unitPrice * 1 // 修正：使用单价乘以数量计算金额
				}))
				this.quotationForm.products = [...(this.quotationForm.products || []), ...newProducts]
				this.calculateTotalAmount()
				this.productSelectorVisible = false
			},
			calculateItemAmount(index) {
				const item = this.quotationForm.products[index]
				item.amount = item.quantity * item.unitPrice
				this.calculateTotalAmount()
			},
			calculateTotalAmount() {
				if (!this.quotationForm.products) return
				const total = this.quotationForm.products.reduce((sum, item) => sum + (item.amount || 0), 0)
				const totalCost = this.quotationForm.products.reduce((sum, item) => sum + (item.quantity * item
					.costPrice || 0), 0)
				this.quotationForm.offerPrice = total
				this.quotationForm.cost = totalCost
				this.quotationForm.profit = total - totalCost
			},
			removeQuotationItem(index) {
				this.quotationForm.products.splice(index, 1)
				this.calculateTotalAmount()
			},
			showAddProduct() {
				this.productForm = {
					name: '',
					specification: '',
					unit: '',
					price: 0,
					costPrice: 0,
					remark: ''
				}
				this.addProductVisible = true
			},
			async submitProductForm() {
				try {
					await this.$refs.productForm.validate()
					await addProduct(this.productForm)
					this.$message.success('添加成功')
					this.addProductVisible = false
					await this.fetchProducts()
				} catch (error) {
					console.error('提交产品表单失败:', error)
				}
			},
			handleAddApproval() {
				this.approvalFormTitle = '新建审批'
				this.approvalForm = {
					examineName: '',
					examineTemId: '',
					oaType: 'quotation',
					businessId: this.viewOpportunity.id,
					businessName: this.viewOpportunity.name,
					customerId: this.viewOpportunity.customerId,
					customerName: this.viewOpportunity.customerName,
					description: ''
				}
				this.approvalFormVisible = true
			},
			async submitApprovalForm() {
				try {
					await this.$refs.approvalForm.validate()
					await addApproval(this.approvalForm)
					this.$message.success('创建成功')
					this.approvalFormVisible = false
					await this.fetchApprovalList()
				} catch (error) {
					console.error('提交审批表单失败:', error)
				}
			},
			async handleSubmitApproval(row) {
				try {
					await this.$confirm('确认提交该审批吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					await submitApproval(row.id)
					this.$message.success('提交成功')
					await this.fetchApprovalList()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('提交审批失败:', error)
					}
				}
			},
			async handleWithdrawApproval(row) {
				try {
					await this.$confirm('确认撤回该审批吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					await withdrawApproval(row.id)
					this.$message.success('撤回成功')
					await this.fetchApprovalList()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('撤回审批失败:', error)
					}
				}
			},
			getTypeText(type) {
				const typeMap = {
					'quotation': '报价审批',
					'contract': '合同审批',
					'other': '其他审批'
				}
				return typeMap[type] || '未知类型'
			},
			getTimelineItemType(status) {
				const typeMap = {
					0: 'warning', // 待审批
					1: 'success', // 已通过
					2: 'danger' // 已拒绝
				}
				return typeMap[status] || 'info'
			},
			// 获取审批模板列表
			async fetchTemplates() {
				try {
					const res = await getExamineTem()
					this.templateList = res.data
				} catch (error) {
					console.error('获取审批模板列表失败:', error)
				}
			},

			// 处理模板选择变化
			handleTemplateChange(templateId) {
				const selectedTemplate = this.templateList.find(t => t.id === templateId)
				if (selectedTemplate) {
					this.approvalForm.examineName = selectedTemplate.name
				}
			},
			// 添加合同
			handleAddContract() {
				this.contractFormTitle = '新建合同'
				this.contractForm = {
					contractNumber: '',
					contractName: '',
					customerId: this.viewOpportunity.customerId,
					customerName: this.viewOpportunity.customerName,
					businessId: this.viewOpportunity.id,
					businessName: this.viewOpportunity.name,
					totalAmount: 0,
					signedDate: '',
					startDate: '',
					endDate: '',
					paymentTerms: '',
					notes: '',
					contractFile: '',
					status: 9
				}
				this.contractFileList = []
				this.contractFormVisible = true
			},

			// 编辑合同
			handleEditContract(row) {
				this.contractFormTitle = '编辑合同'
				this.contractForm = {
					...row,
					businessId: this.viewOpportunity.id,
					businessName: this.viewOpportunity.name,
					customerId: this.viewOpportunity.customerId,
					customerName: this.viewOpportunity.customerName
				}
				if (row.contractFile) {
					this.contractFileList = [{
						name: row.contractFile.split('/').pop(),
						url: row.contractFile
					}]
				}
				this.contractFormVisible = true
			},

			// 获取合同审批列表


			// 提交合同表单
			async submitContractForm() {
				try {
					await this.$refs.contractForm.validate()
					const formData = {
						...this.contractForm,
						contractFile: this.contractForm.contractFile,
						status: this.contractForm.status || 9
					}

					if (this.contractForm.id) {
						await updateContract(formData)
						this.$message.success('更新成功')
					} else {
						await createContract(formData)
						this.$message.success('创建成功')
					}
					this.contractFormVisible = false
					await this.fetchContractList(this.viewOpportunity.id)
				} catch (error) {
					console.error('提交合同表单失败:', error)
				}
			},

			// 提交合同审批
			async handleSubmitContract(row) {
				try {
					if (row.status === 0) {
						// 撤回审批
						await this.$confirm('确认撤回该合同的审批吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						})
						await withdrawContract({
							contractId: row.id
						})
						this.$message.success('撤回成功')
					} else {
						// 提交审批
						this.contractSubmitForm = {
							id: row.id,
							contractNumber: row.contractNumber,
							contractName: row.contractName,
							customerId: row.customerId,
							customerName: row.customerName,
							businessId: row.businessId,
							businessName: row.businessName,
							totalAmount: row.totalAmount,
							signedDate: row.signedDate,
							startDate: row.startDate,
							endDate: row.endDate,
							paymentTerms: row.paymentTerms,
							notes: row.notes,
							contractFile: row.contractFile
						}
						this.contractSubmitDialogVisible = true
					}
					await this.fetchContractList(this.viewOpportunity.id)
				} catch (error) {
					if (error !== 'cancel') {
						console.error('操作失败:', error)
					}
				}
			},

			// 确认提交合同审批
			async confirmContractSubmit() {
				try {
					await this.$refs.contractSubmitFormRef.validate()
					this.contractSubmitForm.status = 0
					await submitContract(this.contractSubmitForm)
					this.$message.success('提交成功')
					this.contractSubmitDialogVisible = false
					await this.fetchContractList(this.viewOpportunity.id)
				} catch (error) {
					if (error !== 'cancel') {
						console.error('提交合同失败:', error)
						this.$message.error('提交失败')
					}
				}
			},

			// 查看合同审批详情
			async handleViewContractApproval(row) {
				this.viewApproval = {
					...row
				}
				this.handleApprove(row)
				this.viewApprovalDialogVisible = true
				this.activeApprovalTab = 'basic'
			},

			// 添加回款
			handleAddPayment() {
				this.paymentFormTitle = '新建回款'
				this.paymentForm = {
					number: '',
					customerId: this.viewOpportunity.customerId,
					customerName: this.viewOpportunity.customerName,
					businessId: this.viewOpportunity.id,
					businessName: this.viewOpportunity.name,
					money: 0,
					returnTime: '',
					returnType: '',
					remark: ''
				}
				this.paymentFormVisible = true
			},

			// 编辑回款
			handleEditPayment(row) {
				this.paymentFormTitle = '编辑回款'
				this.paymentForm = {
					...row,
					receiptFile: row.receiptFile,
					businessId: this.viewOpportunity.id,
					businessName: this.viewOpportunity.name,
					customerId: this.viewOpportunity.customerId,
					customerName: this.viewOpportunity.customerName
				}
				if (row.receiptFile) {
					this.receiptFileList = [{
						name: row.receiptFile.split('/').pop(),
						url: '/api/move/getOssFile?name=' + row.receiptFile
					}]
				}
				this.paymentFormVisible = true
			},



			// 提交回款表单
			async submitPaymentForm() {
				try {
					await this.$refs.paymentForm.validate()
					if (this.paymentForm.id) {
						await updatePayment(this.paymentForm)
						this.$message.success('更新成功')
					} else {
						await createPayment(this.paymentForm)
						this.$message.success('创建成功')
					}
					this.paymentFormVisible = false
					await this.fetchPaymentList(this.viewOpportunity.id)
				} catch (error) {
					console.error('提交回款表单失败:', error)
				}
			},

			// 提交回款审批
			async handleSubmitPayment(row) {
				try {
					if (row.status === 0) {
						// 撤回审批
						await this.$confirm('确认撤回该回款的审批吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						})
						await withdrawPayment({
							paymentId: row.id
						})
						this.$message.success('撤回成功')
					} else {
						// 提交审批
						this.paymentSubmitForm = {
							id: row.id,
							number: row.number,
							customerId: row.customerId,
							customerName: row.customerName,
							businessId: row.businessId,
							businessName: row.businessName,
							money: row.money,
							returnTime: row.returnTime,
							returnType: row.returnType,
							remark: row.remark
						}
						this.paymentSubmitDialogVisible = true
					}
					await this.fetchPaymentList(this.viewOpportunity.id)
				} catch (error) {
					if (error !== 'cancel') {
						console.error('操作失败:', error)
					}
				}
			},

			// 确认提交回款审批
			async confirmPaymentSubmit() {
				try {
					await this.$refs.paymentSubmitFormRef.validate()
					this.paymentSubmitForm.status = 0
					await submitPayment(this.paymentSubmitForm)
					this.$message.success('提交成功')
					this.paymentSubmitDialogVisible = false
					await this.fetchPaymentList(this.viewOpportunity.id)
				} catch (error) {
					if (error !== 'cancel') {
						console.error('提交回款失败:', error)
						this.$message.error('提交失败')
					}
				}
			},

			// 查看回款审批详情
			async handleViewPaymentApproval(row) {
				this.viewApproval = {
					...row
				}
				this.handleApprove(row)
				this.viewApprovalDialogVisible = true
				this.activeApprovalTab = 'basic'
			},

			// 合同文件上传相关方法
			handleContractFilePreview(file) {
				window.open(file.url)
			},
			handleContractFileRemove() {
				this.contractForm.contractFile = ''
				this.contractFileList = []
			},
			handleContractFileSuccess(response, file) {
				this.contractForm.contractFile = response.data
				this.contractFileList = [{
					name: file.name,
					url: response.data
				}]
			},
			// 回款单上传相关方法
			handleReceiptFilePreview(file) {
				window.open(file.url)
			},
			handleReceiptFileRemove() {
				this.paymentForm.receiptFile = ''
				this.receiptFileList = []
			},
			handleReceiptFileSuccess(response, file) {
				this.paymentForm.receiptFile = response.data
				this.receiptFileList = [{
					name: file.name,
					url: '/api/move/getOssFile?name=' + response.data
				}]
			},
			beforeReceiptFileUpload(file) {
				// 更新 token，以防 token 过期
				this.uploadHeaders.Authorization = localStorage.getItem('token') || ''

				const isPDF = file.type === 'application/pdf'
				const isImage = file.type.startsWith('image/')
				const isLt10M = true

				if (!isPDF && !isImage) {
					ElMessage.error('只能上传PDF或图片文件!')
					return false
				}
				if (!isLt10M) {
					ElMessage.error('文件大小不能超过 10MB!')
					return false
				}
				return true
			},
			handleReceiptFileExceed() {
				ElMessage.warning('只能上传一个文件')
			},
			beforeContractFileUpload(file) {
				// 更新 token，以防 token 过期
				this.uploadHeaders.Authorization = localStorage.getItem('token') || ''

				const isPDF = file.type === 'application/pdf'
				const isLt10M = true

				if (!isPDF) {
					this.$message.error('只能上传PDF文件!')
					return false
				}
				if (!isLt10M) {
					this.$message.error('文件大小不能超过 10MB!')
					return false
				}
				return true
			},
			handleContractFileExceed() {
				this.$message.warning('只能上传一个文件')
			},
			getPaymentTypeTag(type) {
				const typeMap = {
					cash: 'success',
					bank: 'primary',
					check: 'warning',
					other: 'info'
				}
				return typeMap[type] || 'info'
			},
			getPaymentTypeText(type) {
				const typeMap = {
					cash: '现金',
					bank: '银行转账',
					check: '支票',
					other: '其他'
				}
				return typeMap[type] || '未知'
			},
			getTeamRoleType(role) {
				const typeMap = {
					3: 'danger',
					0: 'primary',
					1: 'success',
					2: 'info'
				}
				return typeMap[role] || 'info'
			},
			getTeamRoleText(role) {
				const textMap = {
					3: '负责人',
					0: '销售',
					1: '技术支持',
					2: '其他'
				}
				return textMap[role] || '未知'
			},
			async handleAddTeamMember() {
				this.teamMemberForm = {
					userId: '',
					role: '',
					businessId: this.viewOpportunity.id
				}
				this.teamMemberDialogVisible = true
			},
			async handleRemoveTeamMember(row) {
				try {
					await this.$confirm('确认移除该团队成员吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					await removeTeamMember({
						id: row.id
					})
					this.$message.success('移除成功')
					await this.fetchTeamList(this.viewOpportunity.id)
				} catch (error) {
					if (error !== 'cancel') {
						console.error('移除团队成员失败:', error)
					}
				}
			},
			async submitTeamMember() {
				try {
					await this.$refs.teamMemberForm.validate()
					this.teamMemberForm.businessId = this.viewOpportunity.id
					await addTeamMember(this.teamMemberForm)
					this.$message.success('添加成功')
					this.teamMemberDialogVisible = false
					await this.fetchTeamList(this.viewOpportunity.id)
				} catch (error) {
					console.error('添加团队成员失败:', error)
				}
			},
			async handleUserSearch(query) {
				if (query) {
					this.userSearchLoading = true
					try {
						const res = await searchUsers({
							name: query
						})
						this.userOptions = res.data
					} catch (error) {
						console.error('搜索用户失败:', error)
						ElMessage.error('搜索用户失败')
					} finally {
						this.userSearchLoading = false
					}
				} else {
					this.userOptions = []
				}
			},
			async fetchTeamList(businessId) {
				try {
					const res = await getTeamList({
						businessId
					})
					this.teamList = res.data
				} catch (error) {
					console.error('获取团队成员列表失败:', error)
				}
			},
		}
	}
</script>

<style scoped>
	.pagination-container {
		margin-top: 20px;
		text-align: right;
	}

	.followup-header {
		margin-bottom: 20px;
		text-align: right;
	}

	.followup-user {
		color: #909399;
		font-size: 12px;
		margin-top: 5px;
	}

	.el-timeline {
		padding: 20px;
	}

	.el-timeline-item__content h4 {
		margin: 0;
		font-size: 14px;
		color: #303133;
	}

	.el-timeline-item__content p {
		margin: 5px 0;
		font-size: 13px;
		color: #606266;
	}

	.el-upload--picture-card {
		width: 100px;
		height: 100px;
		line-height: 100px;
		position: relative;
		overflow: hidden;
	}

	.el-upload--picture-card .el-icon {
		font-size: 28px;
		color: #8c939d;
	}

	.el-upload-list--picture-card .el-upload-list__item {
		width: 100px;
		height: 100px;
		position: relative;
	}

	.el-upload-list--picture-card .el-upload-list__item img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.followup-card {
		margin-bottom: 10px;
	}

	.followup-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.followup-title {
		font-size: 16px;
		font-weight: bold;
		color: #303133;
	}

	.followup-content {
		padding: 10px 0;
	}

	.followup-info {
		margin-bottom: 15px;
		color: #606266;
	}

	.followup-info p {
		margin: 5px 0;
		font-size: 14px;
		display: flex;
		align-items: center;
	}

	.followup-info i {
		margin-right: 8px;
		font-size: 16px;
	}

	.followup-notes {
		margin: 15px 0;
		padding: 10px;
		background-color: #f5f7fa;
		border-radius: 4px;
	}

	.followup-notes h4 {
		margin: 0 0 10px 0;
		color: #303133;
		font-size: 14px;
	}

	.followup-notes p {
		margin: 0;
		color: #606266;
		font-size: 14px;
		line-height: 1.6;
		white-space: pre-wrap;
	}

	.followup-photos {
		margin-top: 15px;
	}

	.followup-photos h4 {
		margin: 0 0 10px 0;
		color: #303133;
		font-size: 14px;
	}

	.followup-photo {
		width: 100px;
		height: 100px;
		margin-right: 10px;
		margin-bottom: 10px;
		border-radius: 4px;
		cursor: pointer;
	}

	.el-timeline-item__content {
		margin-left: 10px;
	}

	.el-timeline-item__timestamp {
		color: #909399;
		font-size: 13px;
	}

	.uploaded-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.upload-trigger {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.uploaded-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.team-header {
		margin-bottom: 20px;
		text-align: right;
	}

	.team-member {
		color: #909399;
		font-size: 12px;
		margin-top: 5px;
	}
</style>
